// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AppControllerRootData, AppControllerRootResponses, AppControllerStatusData, AppControllerStatusResponses, AreaTypeControllerCreateData, AreaTypeControllerCreateResponses, AreaTypeControllerDeleteData, AreaTypeControllerDeleteResponses, AreaTypeControllerListData, AreaTypeControllerListResponses, AreaTypeControllerReadData, AreaTypeControllerReadResponses, AreaTypeControllerUpdateData, AreaTypeControllerUpdateResponses, CepApiControllerGetAccountSiteDetailsData, CepApiControllerGetAccountSiteDetailsResponses, CepApiControllerGetAllAccountSitesData, CepApiControllerGetAllAccountSitesResponses, CepApiControllerGetUserOpportunitiesData, CepApiControllerGetUserOpportunitiesResponses, DefinitionControllerDeleteData, DefinitionControllerDeleteResponses, DefinitionControllerReadData, DefinitionControllerReadResponses, DefinitionControllerUpdateData, DefinitionControllerUpdateResponses, DefinitionSetControllerCreateData, DefinitionSetControllerCreateDefinitionData, DefinitionSetControllerCreateDefinitionResponses, DefinitionSetControllerCreateResponses, DefinitionSetControllerDeleteData, DefinitionSetControllerDeleteResponses, DefinitionSetControllerListData, DefinitionSetControllerListResponses, DefinitionSetControllerReadData, DefinitionSetControllerReadResponses, DefinitionSetControllerUpdateData, DefinitionSetControllerUpdateResponses, LearningMaterialsControllerListHtmlFilesData, LearningMaterialsControllerListHtmlFilesResponses, LocalizationControllerBulkCreateTranslationsData, LocalizationControllerBulkCreateTranslationsResponses, LocalizationControllerBulkCreateUiLocalizationsData, LocalizationControllerBulkCreateUiLocalizationsResponses, LocalizationControllerCreateLanguageData, LocalizationControllerCreateLanguageResponses, LocalizationControllerCreateTranslationData, LocalizationControllerCreateTranslationResponses, LocalizationControllerCreateUiLocalizationData, LocalizationControllerCreateUiLocalizationResponses, LocalizationControllerDeleteTranslationData, LocalizationControllerDeleteTranslationResponses, LocalizationControllerDeleteUiLocalizationData, LocalizationControllerDeleteUiLocalizationResponses, LocalizationControllerGetAllLanguagesData, LocalizationControllerGetAllLanguagesResponses, LocalizationControllerGetAllOriginalStringsData, LocalizationControllerGetAllOriginalStringsResponses, LocalizationControllerGetAllTranslationsData, LocalizationControllerGetAllTranslationsResponses, LocalizationControllerGetLanguageProgressData, LocalizationControllerGetLanguageProgressResponses, LocalizationControllerGetUiLocalizationsData, LocalizationControllerGetUiLocalizationsResponses, LocalizationControllerTranslateTextData, LocalizationControllerTranslateTextResponses, LocalizationControllerUpdateTranslationData, LocalizationControllerUpdateTranslationResponses, LocalizationControllerUpdateUiLocalizationData, LocalizationControllerUpdateUiLocalizationResponses, OpportunitiesControllerRedirectToProjectReportData, ProjectsControllerAddAreasData, ProjectsControllerAddAreasResponses, ProjectsControllerAddBulkSolutionsData, ProjectsControllerAddBulkSolutionsResponses, ProjectsControllerAddImageToProjectData, ProjectsControllerAddImageToProjectResponses, ProjectsControllerAddImageToScenarioData, ProjectsControllerAddImageToScenarioResponses, ProjectsControllerAddMembersData, ProjectsControllerAddMembersResponses, ProjectsControllerAddRisksData, ProjectsControllerAddRisksResponses, ProjectsControllerCreateCustomScenarioData, ProjectsControllerCreateCustomScenarioResponses, ProjectsControllerCreateCustomSolutionData, ProjectsControllerCreateCustomSolutionResponses, ProjectsControllerCreateData, ProjectsControllerCreateResponses, ProjectsControllerCreateScenarioData, ProjectsControllerCreateScenarioResponses, ProjectsControllerCreateSolutionData, ProjectsControllerCreateSolutionResponses, ProjectsControllerDeleteAreaData, ProjectsControllerDeleteAreaResponses, ProjectsControllerDeleteData, ProjectsControllerDeleteMembersData, ProjectsControllerDeleteMembersResponses, ProjectsControllerDeleteProjectImageData, ProjectsControllerDeleteProjectImageResponses, ProjectsControllerDeleteResponses, ProjectsControllerDeleteRiskData, ProjectsControllerDeleteRiskResponses, ProjectsControllerDeleteScenarioData, ProjectsControllerDeleteScenarioImageData, ProjectsControllerDeleteScenarioImageResponses, ProjectsControllerDeleteScenarioResponses, ProjectsControllerDeleteSolutionData, ProjectsControllerDeleteSolutionResponses, ProjectsControllerGetAreaData, ProjectsControllerGetAreaResponses, ProjectsControllerGetAreasData, ProjectsControllerGetAreasResponses, ProjectsControllerGetMapMarkersData, ProjectsControllerGetMapMarkersResponses, ProjectsControllerGetMembersData, ProjectsControllerGetMembersResponses, ProjectsControllerGetProjectImageData, ProjectsControllerGetProjectImageResponses, ProjectsControllerGetRiskData, ProjectsControllerGetRiskResponses, ProjectsControllerGetRisksData, ProjectsControllerGetRisksResponses, ProjectsControllerGetScenarioData, ProjectsControllerGetScenarioImageData, ProjectsControllerGetScenarioImageResponses, ProjectsControllerGetScenarioResponses, ProjectsControllerGetScenariosData, ProjectsControllerGetScenariosResponses, ProjectsControllerGetSolutionData, ProjectsControllerGetSolutionResponses, ProjectsControllerGetSolutionsData, ProjectsControllerGetSolutionsResponses, ProjectsControllerGetSuggestedAreaTypesData, ProjectsControllerGetSuggestedAreaTypesResponses, ProjectsControllerGetSuggestedRiskTypesForAreaData, ProjectsControllerGetSuggestedRiskTypesForAreaResponses, ProjectsControllerGetSuggestedScenariosForRiskData, ProjectsControllerGetSuggestedScenariosForRiskResponses, ProjectsControllerGetSuggestedSolutionsForScenarioData, ProjectsControllerGetSuggestedSolutionsForScenarioResponses, ProjectsControllerInviteMembersData, ProjectsControllerInviteMembersResponses, ProjectsControllerListData, ProjectsControllerListResponses, ProjectsControllerReadData, ProjectsControllerReadResponses, ProjectsControllerUpdateAreaNameData, ProjectsControllerUpdateAreaNameResponses, ProjectsControllerUpdateData, ProjectsControllerUpdateResponses, ProjectsControllerUpdateRiskData, ProjectsControllerUpdateRiskResponses, ProjectsControllerUpdateScenarioData, ProjectsControllerUpdateScenarioResponses, ProxyControllerIngestData, ProxyControllerIngestErrors, ProxyControllerIngestResponses, ReportControllerGeneratePdfData, ReportControllerGeneratePdfResponses, ReportControllerUploadPdfData, ReportControllerUploadPdfResponses, RiskTypeControllerCreateData, RiskTypeControllerCreateResponses, RiskTypeControllerDeleteData, RiskTypeControllerDeleteResponses, RiskTypeControllerListData, RiskTypeControllerListResponses, RiskTypeControllerReadData, RiskTypeControllerReadResponses, RiskTypeControllerUpdateData, RiskTypeControllerUpdateResponses, RiskValueChainControllerCreateAreaTypeRecommendationData, RiskValueChainControllerCreateAreaTypeRecommendationResponses, RiskValueChainControllerCreateData, RiskValueChainControllerCreateResponses, RiskValueChainControllerCreateRiskTypeRecommendationData, RiskValueChainControllerCreateRiskTypeRecommendationResponses, RiskValueChainControllerCreateScenarioTypeRecommendationData, RiskValueChainControllerCreateScenarioTypeRecommendationResponses, RiskValueChainControllerCreateSolutionTypeRecommendationData, RiskValueChainControllerCreateSolutionTypeRecommendationResponses, RiskValueChainControllerDeleteAreaTypeRecommendationData, RiskValueChainControllerDeleteAreaTypeRecommendationResponses, RiskValueChainControllerDeleteData, RiskValueChainControllerDeleteResponses, RiskValueChainControllerDeleteRiskTypeRecommendationData, RiskValueChainControllerDeleteRiskTypeRecommendationResponses, RiskValueChainControllerDeleteScenarioTypeRecommendationData, RiskValueChainControllerDeleteScenarioTypeRecommendationResponses, RiskValueChainControllerDeleteSolutionTypeRecommendationData, RiskValueChainControllerDeleteSolutionTypeRecommendationResponses, RiskValueChainControllerDuplicateData, RiskValueChainControllerDuplicateResponses, RiskValueChainControllerGetRiskTypeRecommendationsData, RiskValueChainControllerGetRiskTypeRecommendationsResponses, RiskValueChainControllerListData, RiskValueChainControllerListResponses, RiskValueChainControllerReadData, RiskValueChainControllerReadResponses, RiskValueChainControllerUpdateData, RiskValueChainControllerUpdateResponses, ScenarioTypeControllerCreateData, ScenarioTypeControllerCreateResponses, ScenarioTypeControllerDeleteData, ScenarioTypeControllerDeleteResponses, ScenarioTypeControllerListData, ScenarioTypeControllerListResponses, ScenarioTypeControllerReadData, ScenarioTypeControllerReadResponses, ScenarioTypeControllerUpdateData, ScenarioTypeControllerUpdateResponses, SolutionImageControllerDeleteSolutionImageData, SolutionImageControllerDeleteSolutionImageResponses, SolutionImageControllerGetBatchSolutionImagesData, SolutionImageControllerGetBatchSolutionImagesResponses, SolutionImageControllerGetSolutionImageData, SolutionImageControllerGetSolutionImageResponses, SolutionImageControllerGetSolutionImagesData, SolutionImageControllerGetSolutionImagesResponses, SolutionImageControllerUploadSolutionImageData, SolutionImageControllerUploadSolutionImageResponses, SolutionTypeControllerCreateData, SolutionTypeControllerCreateResponses, SolutionTypeControllerDeleteData, SolutionTypeControllerDeleteResponses, SolutionTypeControllerGetCategoriesData, SolutionTypeControllerGetCategoriesResponses, SolutionTypeControllerListData, SolutionTypeControllerListResponses, SolutionTypeControllerReadData, SolutionTypeControllerReadResponses, SolutionTypeControllerUpdateData, SolutionTypeControllerUpdateResponses, TelemetryControllerTrackData, TelemetryControllerTrackResponses, TextRefinementControllerStreamRefinementData, TextRefinementControllerStreamRefinementResponses, TextRefinementControllerStreamShorteningData, TextRefinementControllerStreamShorteningResponses, TextRefinementControllerStreamTranslationData, TextRefinementControllerStreamTranslationResponses, UserControllerGetAllRolesData, UserControllerGetAllRolesResponses, UserControllerGetAllUsersData, UserControllerGetAllUsersResponses, UserControllerGetMyUserData, UserControllerGetMyUserResponses, UserControllerGetMyUserRolesData, UserControllerGetMyUserRolesResponses, UserControllerGetMyUserWorkspacesData, UserControllerGetMyUserWorkspacesResponses, UserControllerGetUserByEmailData, UserControllerGetUserByEmailResponses, UserControllerGetUserByEntraIdData, UserControllerGetUserByEntraIdResponses, UserControllerGetUserByIdData, UserControllerGetUserByIdResponses, UserControllerSetUserLanguageData, UserControllerSetUserLanguageResponses, UserControllerUpdateUserData, UserControllerUpdateUserResponses, V1AppControllerRootData, V1AppControllerRootResponses, V1AppControllerStatusData, V1AppControllerStatusResponses, V1AreaTypeControllerCreateData, V1AreaTypeControllerCreateResponses, V1AreaTypeControllerDeleteData, V1AreaTypeControllerDeleteResponses, V1AreaTypeControllerListData, V1AreaTypeControllerListResponses, V1AreaTypeControllerReadData, V1AreaTypeControllerReadResponses, V1AreaTypeControllerUpdateData, V1AreaTypeControllerUpdateResponses, V1CepApiControllerGetAccountSiteDetailsData, V1CepApiControllerGetAccountSiteDetailsResponses, V1CepApiControllerGetAllAccountSitesData, V1CepApiControllerGetAllAccountSitesResponses, V1CepApiControllerGetUserOpportunitiesData, V1CepApiControllerGetUserOpportunitiesResponses, V1DefinitionControllerDeleteData, V1DefinitionControllerDeleteResponses, V1DefinitionControllerReadData, V1DefinitionControllerReadResponses, V1DefinitionControllerUpdateData, V1DefinitionControllerUpdateResponses, V1DefinitionSetControllerCreateData, V1DefinitionSetControllerCreateDefinitionData, V1DefinitionSetControllerCreateDefinitionResponses, V1DefinitionSetControllerCreateResponses, V1DefinitionSetControllerDeleteData, V1DefinitionSetControllerDeleteResponses, V1DefinitionSetControllerListData, V1DefinitionSetControllerListResponses, V1DefinitionSetControllerReadData, V1DefinitionSetControllerReadResponses, V1DefinitionSetControllerUpdateData, V1DefinitionSetControllerUpdateResponses, V1LearningMaterialsControllerListHtmlFilesData, V1LearningMaterialsControllerListHtmlFilesResponses, V1LocalizationControllerBulkCreateTranslationsData, V1LocalizationControllerBulkCreateTranslationsResponses, V1LocalizationControllerBulkCreateUiLocalizationsData, V1LocalizationControllerBulkCreateUiLocalizationsResponses, V1LocalizationControllerCreateLanguageData, V1LocalizationControllerCreateLanguageResponses, V1LocalizationControllerCreateTranslationData, V1LocalizationControllerCreateTranslationResponses, V1LocalizationControllerCreateUiLocalizationData, V1LocalizationControllerCreateUiLocalizationResponses, V1LocalizationControllerDeleteTranslationData, V1LocalizationControllerDeleteTranslationResponses, V1LocalizationControllerDeleteUiLocalizationData, V1LocalizationControllerDeleteUiLocalizationResponses, V1LocalizationControllerGetAllLanguagesData, V1LocalizationControllerGetAllLanguagesResponses, V1LocalizationControllerGetAllOriginalStringsData, V1LocalizationControllerGetAllOriginalStringsResponses, V1LocalizationControllerGetAllTranslationsData, V1LocalizationControllerGetAllTranslationsResponses, V1LocalizationControllerGetLanguageProgressData, V1LocalizationControllerGetLanguageProgressResponses, V1LocalizationControllerGetUiLocalizationsData, V1LocalizationControllerGetUiLocalizationsResponses, V1LocalizationControllerTranslateTextData, V1LocalizationControllerTranslateTextResponses, V1LocalizationControllerUpdateTranslationData, V1LocalizationControllerUpdateTranslationResponses, V1LocalizationControllerUpdateUiLocalizationData, V1LocalizationControllerUpdateUiLocalizationResponses, V1OpportunitiesControllerRedirectToProjectReportData, V1ProjectsControllerAddAreasData, V1ProjectsControllerAddAreasResponses, V1ProjectsControllerAddBulkSolutionsData, V1ProjectsControllerAddBulkSolutionsResponses, V1ProjectsControllerAddImageToProjectData, V1ProjectsControllerAddImageToProjectResponses, V1ProjectsControllerAddImageToScenarioData, V1ProjectsControllerAddImageToScenarioResponses, V1ProjectsControllerAddMembersData, V1ProjectsControllerAddMembersResponses, V1ProjectsControllerAddRisksData, V1ProjectsControllerAddRisksResponses, V1ProjectsControllerCreateCustomScenarioData, V1ProjectsControllerCreateCustomScenarioResponses, V1ProjectsControllerCreateCustomSolutionData, V1ProjectsControllerCreateCustomSolutionResponses, V1ProjectsControllerCreateData, V1ProjectsControllerCreateResponses, V1ProjectsControllerCreateScenarioData, V1ProjectsControllerCreateScenarioResponses, V1ProjectsControllerCreateSolutionData, V1ProjectsControllerCreateSolutionResponses, V1ProjectsControllerDeleteAreaData, V1ProjectsControllerDeleteAreaResponses, V1ProjectsControllerDeleteData, V1ProjectsControllerDeleteMembersData, V1ProjectsControllerDeleteMembersResponses, V1ProjectsControllerDeleteProjectImageData, V1ProjectsControllerDeleteProjectImageResponses, V1ProjectsControllerDeleteResponses, V1ProjectsControllerDeleteRiskData, V1ProjectsControllerDeleteRiskResponses, V1ProjectsControllerDeleteScenarioData, V1ProjectsControllerDeleteScenarioImageData, V1ProjectsControllerDeleteScenarioImageResponses, V1ProjectsControllerDeleteScenarioResponses, V1ProjectsControllerDeleteSolutionData, V1ProjectsControllerDeleteSolutionResponses, V1ProjectsControllerGetAccountSitesData, V1ProjectsControllerGetAccountSitesResponses, V1ProjectsControllerGetAreaData, V1ProjectsControllerGetAreaResponses, V1ProjectsControllerGetAreasData, V1ProjectsControllerGetAreasResponses, V1ProjectsControllerGetMapMarkersData, V1ProjectsControllerGetMapMarkersResponses, V1ProjectsControllerGetMembersData, V1ProjectsControllerGetMembersResponses, V1ProjectsControllerGetProjectImageData, V1ProjectsControllerGetProjectImageResponses, V1ProjectsControllerGetRiskData, V1ProjectsControllerGetRiskResponses, V1ProjectsControllerGetRisksData, V1ProjectsControllerGetRisksResponses, V1ProjectsControllerGetScenarioData, V1ProjectsControllerGetScenarioImageData, V1ProjectsControllerGetScenarioImageResponses, V1ProjectsControllerGetScenarioResponses, V1ProjectsControllerGetScenariosData, V1ProjectsControllerGetScenariosResponses, V1ProjectsControllerGetSolutionData, V1ProjectsControllerGetSolutionResponses, V1ProjectsControllerGetSolutionsData, V1ProjectsControllerGetSolutionsResponses, V1ProjectsControllerGetSuggestedAreaTypesData, V1ProjectsControllerGetSuggestedAreaTypesResponses, V1ProjectsControllerGetSuggestedRiskTypesForAreaData, V1ProjectsControllerGetSuggestedRiskTypesForAreaResponses, V1ProjectsControllerGetSuggestedScenariosForRiskData, V1ProjectsControllerGetSuggestedScenariosForRiskResponses, V1ProjectsControllerGetSuggestedSolutionsForScenarioData, V1ProjectsControllerGetSuggestedSolutionsForScenarioResponses, V1ProjectsControllerInviteMembersData, V1ProjectsControllerInviteMembersResponses, V1ProjectsControllerListData, V1ProjectsControllerListResponses, V1ProjectsControllerReadData, V1ProjectsControllerReadResponses, V1ProjectsControllerUpdateAreaNameData, V1ProjectsControllerUpdateAreaNameResponses, V1ProjectsControllerUpdateData, V1ProjectsControllerUpdateResponses, V1ProjectsControllerUpdateRiskData, V1ProjectsControllerUpdateRiskResponses, V1ProjectsControllerUpdateScenarioData, V1ProjectsControllerUpdateScenarioResponses, V1ProxyControllerIngestData, V1ProxyControllerIngestErrors, V1ProxyControllerIngestResponses, V1ReportControllerGeneratePdfData, V1ReportControllerGeneratePdfResponses, V1ReportControllerUploadPdfData, V1ReportControllerUploadPdfResponses, V1RiskTypeControllerCreateData, V1RiskTypeControllerCreateResponses, V1RiskTypeControllerDeleteData, V1RiskTypeControllerDeleteResponses, V1RiskTypeControllerListData, V1RiskTypeControllerListResponses, V1RiskTypeControllerReadData, V1RiskTypeControllerReadResponses, V1RiskTypeControllerUpdateData, V1RiskTypeControllerUpdateResponses, V1RiskValueChainControllerCreateAreaTypeRecommendationData, V1RiskValueChainControllerCreateAreaTypeRecommendationResponses, V1RiskValueChainControllerCreateData, V1RiskValueChainControllerCreateResponses, V1RiskValueChainControllerCreateRiskTypeRecommendationData, V1RiskValueChainControllerCreateRiskTypeRecommendationResponses, V1RiskValueChainControllerCreateScenarioTypeRecommendationData, V1RiskValueChainControllerCreateScenarioTypeRecommendationResponses, V1RiskValueChainControllerCreateSolutionTypeRecommendationData, V1RiskValueChainControllerCreateSolutionTypeRecommendationResponses, V1RiskValueChainControllerDeleteAreaTypeRecommendationData, V1RiskValueChainControllerDeleteAreaTypeRecommendationResponses, V1RiskValueChainControllerDeleteData, V1RiskValueChainControllerDeleteResponses, V1RiskValueChainControllerDeleteRiskTypeRecommendationData, V1RiskValueChainControllerDeleteRiskTypeRecommendationResponses, V1RiskValueChainControllerDeleteScenarioTypeRecommendationData, V1RiskValueChainControllerDeleteScenarioTypeRecommendationResponses, V1RiskValueChainControllerDeleteSolutionTypeRecommendationData, V1RiskValueChainControllerDeleteSolutionTypeRecommendationResponses, V1RiskValueChainControllerDuplicateData, V1RiskValueChainControllerDuplicateResponses, V1RiskValueChainControllerGetAllRiskTypeRecommendationsData, V1RiskValueChainControllerGetAllRiskTypeRecommendationsResponses, V1RiskValueChainControllerGetRiskTypeRecommendationsData, V1RiskValueChainControllerGetRiskTypeRecommendationsResponses, V1RiskValueChainControllerListData, V1RiskValueChainControllerListResponses, V1RiskValueChainControllerReadData, V1RiskValueChainControllerReadResponses, V1RiskValueChainControllerUpdateData, V1RiskValueChainControllerUpdateResponses, V1ScenarioTypeControllerCreateData, V1ScenarioTypeControllerCreateResponses, V1ScenarioTypeControllerDeleteData, V1ScenarioTypeControllerDeleteResponses, V1ScenarioTypeControllerListData, V1ScenarioTypeControllerListResponses, V1ScenarioTypeControllerReadData, V1ScenarioTypeControllerReadResponses, V1ScenarioTypeControllerUpdateData, V1ScenarioTypeControllerUpdateResponses, V1SolutionImageControllerDeleteSolutionImageData, V1SolutionImageControllerDeleteSolutionImageResponses, V1SolutionImageControllerGetBatchSolutionImagesData, V1SolutionImageControllerGetBatchSolutionImagesResponses, V1SolutionImageControllerGetSolutionImageData, V1SolutionImageControllerGetSolutionImageResponses, V1SolutionImageControllerGetSolutionImagesData, V1SolutionImageControllerGetSolutionImagesResponses, V1SolutionImageControllerUploadSolutionImageData, V1SolutionImageControllerUploadSolutionImageResponses, V1SolutionTypeControllerCreateData, V1SolutionTypeControllerCreateResponses, V1SolutionTypeControllerDeleteData, V1SolutionTypeControllerDeleteResponses, V1SolutionTypeControllerGetCategoriesData, V1SolutionTypeControllerGetCategoriesResponses, V1SolutionTypeControllerListData, V1SolutionTypeControllerListResponses, V1SolutionTypeControllerPreviewData, V1SolutionTypeControllerPreviewResponses, V1SolutionTypeControllerReadData, V1SolutionTypeControllerReadResponses, V1SolutionTypeControllerUpdateData, V1SolutionTypeControllerUpdateResponses, V1TelemetryControllerTrackData, V1TelemetryControllerTrackResponses, V1TextRefinementControllerStreamRefinementData, V1TextRefinementControllerStreamRefinementResponses, V1TextRefinementControllerStreamShorteningData, V1TextRefinementControllerStreamShorteningResponses, V1TextRefinementControllerStreamTranslationData, V1TextRefinementControllerStreamTranslationResponses, V1UserControllerGetAllRolesData, V1UserControllerGetAllRolesResponses, V1UserControllerGetAllUsersData, V1UserControllerGetAllUsersResponses, V1UserControllerGetMyUserData, V1UserControllerGetMyUserResponses, V1UserControllerGetMyUserRolesData, V1UserControllerGetMyUserRolesResponses, V1UserControllerGetMyUserWorkspacesData, V1UserControllerGetMyUserWorkspacesResponses, V1UserControllerGetUserByEmailData, V1UserControllerGetUserByEmailResponses, V1UserControllerGetUserByEntraIdData, V1UserControllerGetUserByEntraIdResponses, V1UserControllerGetUserByIdData, V1UserControllerGetUserByIdResponses, V1UserControllerSetUserLanguageData, V1UserControllerSetUserLanguageResponses, V1UserControllerUpdateUserData, V1UserControllerUpdateUserResponses, V1WebReportControllerCreateData, V1WebReportControllerCreateResponses, V1WebReportControllerGetData, V1WebReportControllerGetPublicCoverImageData, V1WebReportControllerGetPublicCoverImageResponses, V1WebReportControllerGetPublicReportData, V1WebReportControllerGetPublicReportResponses, V1WebReportControllerGetPublicScenarioImageData, V1WebReportControllerGetPublicScenarioImageResponses, V1WebReportControllerGetPublicSolutionImageData, V1WebReportControllerGetPublicSolutionImageResponses, V1WebReportControllerGetResponses, V1WebReportControllerListAccessData, V1WebReportControllerListAccessResponses, V1WebReportControllerPublishData, V1WebReportControllerPublishResponses, V1WebReportControllerRenewAccessData, V1WebReportControllerRenewAccessResponses, V1WebReportControllerResendAccessData, V1WebReportControllerResendAccessResponses, V1WebReportControllerRevokeAccessData, V1WebReportControllerRevokeAccessResponses, V1WebReportControllerUpdateTemplateData, V1WebReportControllerUpdateTemplateResponses, V1WorkspacesControllerAddAdministratorData, V1WorkspacesControllerAddAdministratorResponses, V1WorkspacesControllerAddMemberData, V1WorkspacesControllerAddMemberResponses, V1WorkspacesControllerAssociateRiskValueChainData, V1WorkspacesControllerAssociateRiskValueChainResponses, V1WorkspacesControllerCreateData, V1WorkspacesControllerCreateResponses, V1WorkspacesControllerDeleteData, V1WorkspacesControllerDeleteResponses, V1WorkspacesControllerDisassociateRiskValueChainData, V1WorkspacesControllerDisassociateRiskValueChainResponses, V1WorkspacesControllerFindAllData, V1WorkspacesControllerFindAllOverviewData, V1WorkspacesControllerFindAllOverviewResponses, V1WorkspacesControllerFindAllResponses, V1WorkspacesControllerGetWorkspaceAssociatedRiskValueChainsData, V1WorkspacesControllerGetWorkspaceAssociatedRiskValueChainsResponses, V1WorkspacesControllerGetWorkspaceAssociatedSolutionTypesData, V1WorkspacesControllerGetWorkspaceAssociatedSolutionTypesResponses, V1WorkspacesControllerGetWorkspaceAvailableRiskValueChainsData, V1WorkspacesControllerGetWorkspaceAvailableRiskValueChainsResponses, V1WorkspacesControllerGetWorkspaceAvailableSolutionTypesData, V1WorkspacesControllerGetWorkspaceAvailableSolutionTypesResponses, V1WorkspacesControllerRemoveAdministratorData, V1WorkspacesControllerRemoveAdministratorResponses, V1WorkspacesControllerRemoveMemberData, V1WorkspacesControllerRemoveMemberResponses, V1WorkspacesControllerUpdateData, V1WorkspacesControllerUpdateMemberData, V1WorkspacesControllerUpdateMemberResponses, V1WorkspacesControllerUpdateResponses, V1WorkspacesControllerUpdateRiskValueChainAssociationsData, V1WorkspacesControllerUpdateRiskValueChainAssociationsResponses, V1WorkspacesControllerUpdateSolutionTypeAssociationsData, V1WorkspacesControllerUpdateSolutionTypeAssociationsResponses, WebReportControllerCreateData, WebReportControllerCreateResponses, WebReportControllerGetData, WebReportControllerGetPublicCoverImageData, WebReportControllerGetPublicCoverImageResponses, WebReportControllerGetPublicReportData, WebReportControllerGetPublicReportResponses, WebReportControllerGetPublicScenarioImageData, WebReportControllerGetPublicScenarioImageResponses, WebReportControllerGetPublicSolutionImageData, WebReportControllerGetPublicSolutionImageResponses, WebReportControllerGetResponses, WebReportControllerListAccessData, WebReportControllerListAccessResponses, WebReportControllerPublishData, WebReportControllerPublishResponses, WebReportControllerRenewAccessData, WebReportControllerRenewAccessResponses, WebReportControllerResendAccessData, WebReportControllerResendAccessResponses, WebReportControllerRevokeAccessData, WebReportControllerRevokeAccessResponses, WebReportControllerUpdateTemplateData, WebReportControllerUpdateTemplateResponses, WorkspacesControllerAddAdministratorData, WorkspacesControllerAddAdministratorResponses, WorkspacesControllerAddMemberData, WorkspacesControllerAddMemberResponses, WorkspacesControllerAssociateRiskValueChainData, WorkspacesControllerAssociateRiskValueChainResponses, WorkspacesControllerCreateData, WorkspacesControllerCreateResponses, WorkspacesControllerDeleteData, WorkspacesControllerDeleteResponses, WorkspacesControllerDisassociateRiskValueChainData, WorkspacesControllerDisassociateRiskValueChainResponses, WorkspacesControllerFindAllData, WorkspacesControllerFindAllOverviewData, WorkspacesControllerFindAllOverviewResponses, WorkspacesControllerFindAllResponses, WorkspacesControllerGetWorkspaceAssociatedRiskValueChainsData, WorkspacesControllerGetWorkspaceAssociatedRiskValueChainsResponses, WorkspacesControllerGetWorkspaceAssociatedSolutionTypesData, WorkspacesControllerGetWorkspaceAssociatedSolutionTypesResponses, WorkspacesControllerGetWorkspaceAvailableRiskValueChainsData, WorkspacesControllerGetWorkspaceAvailableRiskValueChainsResponses, WorkspacesControllerGetWorkspaceAvailableSolutionTypesData, WorkspacesControllerGetWorkspaceAvailableSolutionTypesResponses, WorkspacesControllerRemoveAdministratorData, WorkspacesControllerRemoveAdministratorResponses, WorkspacesControllerRemoveMemberData, WorkspacesControllerRemoveMemberResponses, WorkspacesControllerUpdateData, WorkspacesControllerUpdateMemberData, WorkspacesControllerUpdateMemberResponses, WorkspacesControllerUpdateResponses, WorkspacesControllerUpdateRiskValueChainAssociationsData, WorkspacesControllerUpdateRiskValueChainAssociationsResponses, WorkspacesControllerUpdateSolutionTypeAssociationsData, WorkspacesControllerUpdateSolutionTypeAssociationsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * @deprecated
 */
export const appControllerRoot = <ThrowOnError extends boolean = false>(options?: Options<AppControllerRootData, ThrowOnError>): RequestResult<AppControllerRootResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AppControllerRootResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/',
    ...options
});

/**
 * @deprecated
 */
export const appControllerStatus = <ThrowOnError extends boolean = false>(options?: Options<AppControllerStatusData, ThrowOnError>): RequestResult<AppControllerStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AppControllerStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/status',
    ...options
});

export const v1AppControllerRoot = <ThrowOnError extends boolean = false>(options?: Options<V1AppControllerRootData, ThrowOnError>): RequestResult<V1AppControllerRootResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1AppControllerRootResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1',
    ...options
});

export const v1AppControllerStatus = <ThrowOnError extends boolean = false>(options?: Options<V1AppControllerStatusData, ThrowOnError>): RequestResult<V1AppControllerStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1AppControllerStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/status',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerList = <ThrowOnError extends boolean = false>(options?: Options<ProjectsControllerListData, ThrowOnError>): RequestResult<ProjectsControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProjectsControllerListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerCreate = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerCreateData, ThrowOnError>): RequestResult<ProjectsControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProjectsControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const projectsControllerGetMapMarkers = <ThrowOnError extends boolean = false>(options?: Options<ProjectsControllerGetMapMarkersData, ThrowOnError>): RequestResult<ProjectsControllerGetMapMarkersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ProjectsControllerGetMapMarkersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/map-markers',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerDelete = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerDeleteData, ThrowOnError>): RequestResult<ProjectsControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ProjectsControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerRead = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerReadData, ThrowOnError>): RequestResult<ProjectsControllerReadResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProjectsControllerReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerUpdateData, ThrowOnError>): RequestResult<ProjectsControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<ProjectsControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const projectsControllerGetMembers = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerGetMembersData, ThrowOnError>): RequestResult<ProjectsControllerGetMembersResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProjectsControllerGetMembersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/members',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerAddMembers = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerAddMembersData, ThrowOnError>): RequestResult<ProjectsControllerAddMembersResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProjectsControllerAddMembersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const projectsControllerInviteMembers = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerInviteMembersData, ThrowOnError>): RequestResult<ProjectsControllerInviteMembersResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProjectsControllerInviteMembersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/members/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const projectsControllerDeleteMembers = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerDeleteMembersData, ThrowOnError>): RequestResult<ProjectsControllerDeleteMembersResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ProjectsControllerDeleteMembersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/members/{memberId}',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerAddAreas = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerAddAreasData, ThrowOnError>): RequestResult<ProjectsControllerAddAreasResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProjectsControllerAddAreasResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/create-bulk-areas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const projectsControllerGetAreas = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerGetAreasData, ThrowOnError>): RequestResult<ProjectsControllerGetAreasResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProjectsControllerGetAreasResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerDeleteArea = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerDeleteAreaData, ThrowOnError>): RequestResult<ProjectsControllerDeleteAreaResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ProjectsControllerDeleteAreaResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerGetArea = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerGetAreaData, ThrowOnError>): RequestResult<ProjectsControllerGetAreaResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProjectsControllerGetAreaResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerUpdateAreaName = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerUpdateAreaNameData, ThrowOnError>): RequestResult<ProjectsControllerUpdateAreaNameResponses, unknown, ThrowOnError> => (options.client ?? client).patch<ProjectsControllerUpdateAreaNameResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const projectsControllerAddRisks = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerAddRisksData, ThrowOnError>): RequestResult<ProjectsControllerAddRisksResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProjectsControllerAddRisksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/create-bulk-risks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const projectsControllerDeleteRisk = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerDeleteRiskData, ThrowOnError>): RequestResult<ProjectsControllerDeleteRiskResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ProjectsControllerDeleteRiskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerGetRisk = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerGetRiskData, ThrowOnError>): RequestResult<ProjectsControllerGetRiskResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProjectsControllerGetRiskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerUpdateRisk = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerUpdateRiskData, ThrowOnError>): RequestResult<ProjectsControllerUpdateRiskResponses, unknown, ThrowOnError> => (options.client ?? client).patch<ProjectsControllerUpdateRiskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const projectsControllerGetRisks = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerGetRisksData, ThrowOnError>): RequestResult<ProjectsControllerGetRisksResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProjectsControllerGetRisksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerGetSuggestedAreaTypes = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerGetSuggestedAreaTypesData, ThrowOnError>): RequestResult<ProjectsControllerGetSuggestedAreaTypesResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProjectsControllerGetSuggestedAreaTypesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/suggested-area-types',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerGetSuggestedRiskTypesForArea = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerGetSuggestedRiskTypesForAreaData, ThrowOnError>): RequestResult<ProjectsControllerGetSuggestedRiskTypesForAreaResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProjectsControllerGetSuggestedRiskTypesForAreaResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/suggested-risk-types',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerGetScenarios = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerGetScenariosData, ThrowOnError>): RequestResult<ProjectsControllerGetScenariosResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProjectsControllerGetScenariosResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerCreateScenario = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerCreateScenarioData, ThrowOnError>): RequestResult<ProjectsControllerCreateScenarioResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProjectsControllerCreateScenarioResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const projectsControllerCreateCustomScenario = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerCreateCustomScenarioData, ThrowOnError>): RequestResult<ProjectsControllerCreateCustomScenarioResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProjectsControllerCreateCustomScenarioResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/custom-scenarios',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const projectsControllerDeleteScenario = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerDeleteScenarioData, ThrowOnError>): RequestResult<ProjectsControllerDeleteScenarioResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ProjectsControllerDeleteScenarioResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerGetScenario = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerGetScenarioData, ThrowOnError>): RequestResult<ProjectsControllerGetScenarioResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProjectsControllerGetScenarioResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerUpdateScenario = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerUpdateScenarioData, ThrowOnError>): RequestResult<ProjectsControllerUpdateScenarioResponses, unknown, ThrowOnError> => (options.client ?? client).patch<ProjectsControllerUpdateScenarioResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const projectsControllerGetSolutions = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerGetSolutionsData, ThrowOnError>): RequestResult<ProjectsControllerGetSolutionsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProjectsControllerGetSolutionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/solutions',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerCreateSolution = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerCreateSolutionData, ThrowOnError>): RequestResult<ProjectsControllerCreateSolutionResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProjectsControllerCreateSolutionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/solutions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const projectsControllerDeleteSolution = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerDeleteSolutionData, ThrowOnError>): RequestResult<ProjectsControllerDeleteSolutionResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ProjectsControllerDeleteSolutionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/solutions/{solutionId}',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerGetSolution = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerGetSolutionData, ThrowOnError>): RequestResult<ProjectsControllerGetSolutionResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProjectsControllerGetSolutionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/solutions/{solutionId}',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerAddBulkSolutions = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerAddBulkSolutionsData, ThrowOnError>): RequestResult<ProjectsControllerAddBulkSolutionsResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProjectsControllerAddBulkSolutionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/create-bulk-solutions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const projectsControllerGetSuggestedScenariosForRisk = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerGetSuggestedScenariosForRiskData, ThrowOnError>): RequestResult<ProjectsControllerGetSuggestedScenariosForRiskResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProjectsControllerGetSuggestedScenariosForRiskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/suggested-scenario-types',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerGetSuggestedSolutionsForScenario = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerGetSuggestedSolutionsForScenarioData, ThrowOnError>): RequestResult<ProjectsControllerGetSuggestedSolutionsForScenarioResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProjectsControllerGetSuggestedSolutionsForScenarioResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/suggested-solution-types',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerDeleteProjectImage = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerDeleteProjectImageData, ThrowOnError>): RequestResult<ProjectsControllerDeleteProjectImageResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ProjectsControllerDeleteProjectImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/image',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerGetProjectImage = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerGetProjectImageData, ThrowOnError>): RequestResult<ProjectsControllerGetProjectImageResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProjectsControllerGetProjectImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/image',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerAddImageToProject = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerAddImageToProjectData, ThrowOnError>): RequestResult<ProjectsControllerAddImageToProjectResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProjectsControllerAddImageToProjectResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const projectsControllerAddImageToScenario = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerAddImageToScenarioData, ThrowOnError>): RequestResult<ProjectsControllerAddImageToScenarioResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProjectsControllerAddImageToScenarioResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/images',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const projectsControllerGetScenarioImage = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerGetScenarioImageData, ThrowOnError>): RequestResult<ProjectsControllerGetScenarioImageResponses, unknown, ThrowOnError> => (options.client ?? client).get<ProjectsControllerGetScenarioImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/images/{scenarioImageId}',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerDeleteScenarioImage = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerDeleteScenarioImageData, ThrowOnError>): RequestResult<ProjectsControllerDeleteScenarioImageResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ProjectsControllerDeleteScenarioImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/images/{imageId}',
    ...options
});

/**
 * @deprecated
 */
export const projectsControllerCreateCustomSolution = <ThrowOnError extends boolean = false>(options: Options<ProjectsControllerCreateCustomSolutionData, ThrowOnError>): RequestResult<ProjectsControllerCreateCustomSolutionResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProjectsControllerCreateCustomSolutionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/custom-solutions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const opportunitiesControllerRedirectToProjectReport = <ThrowOnError extends boolean = false>(options: Options<OpportunitiesControllerRedirectToProjectReportData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/opportunities/{opportunityId}/redirect-to-project-report',
    ...options
});

export const v1ProjectsControllerList = <ThrowOnError extends boolean = false>(options?: Options<V1ProjectsControllerListData, ThrowOnError>): RequestResult<V1ProjectsControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1ProjectsControllerListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects',
    ...options
});

export const v1ProjectsControllerCreate = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerCreateData, ThrowOnError>): RequestResult<V1ProjectsControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1ProjectsControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ProjectsControllerGetMapMarkers = <ThrowOnError extends boolean = false>(options?: Options<V1ProjectsControllerGetMapMarkersData, ThrowOnError>): RequestResult<V1ProjectsControllerGetMapMarkersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1ProjectsControllerGetMapMarkersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/map-markers',
    ...options
});

export const v1ProjectsControllerGetAccountSites = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerGetAccountSitesData, ThrowOnError>): RequestResult<V1ProjectsControllerGetAccountSitesResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerGetAccountSitesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/account-sites',
    ...options
});

export const v1ProjectsControllerDelete = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerDeleteData, ThrowOnError>): RequestResult<V1ProjectsControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1ProjectsControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}',
    ...options
});

export const v1ProjectsControllerRead = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerReadData, ThrowOnError>): RequestResult<V1ProjectsControllerReadResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}',
    ...options
});

export const v1ProjectsControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerUpdateData, ThrowOnError>): RequestResult<V1ProjectsControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1ProjectsControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ProjectsControllerGetMembers = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerGetMembersData, ThrowOnError>): RequestResult<V1ProjectsControllerGetMembersResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerGetMembersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/members',
    ...options
});

export const v1ProjectsControllerAddMembers = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerAddMembersData, ThrowOnError>): RequestResult<V1ProjectsControllerAddMembersResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1ProjectsControllerAddMembersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ProjectsControllerInviteMembers = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerInviteMembersData, ThrowOnError>): RequestResult<V1ProjectsControllerInviteMembersResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1ProjectsControllerInviteMembersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/members/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ProjectsControllerDeleteMembers = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerDeleteMembersData, ThrowOnError>): RequestResult<V1ProjectsControllerDeleteMembersResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1ProjectsControllerDeleteMembersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/members/{memberId}',
    ...options
});

export const v1ProjectsControllerAddAreas = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerAddAreasData, ThrowOnError>): RequestResult<V1ProjectsControllerAddAreasResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1ProjectsControllerAddAreasResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/create-bulk-areas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ProjectsControllerGetAreas = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerGetAreasData, ThrowOnError>): RequestResult<V1ProjectsControllerGetAreasResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerGetAreasResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas',
    ...options
});

export const v1ProjectsControllerDeleteArea = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerDeleteAreaData, ThrowOnError>): RequestResult<V1ProjectsControllerDeleteAreaResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1ProjectsControllerDeleteAreaResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}',
    ...options
});

export const v1ProjectsControllerGetArea = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerGetAreaData, ThrowOnError>): RequestResult<V1ProjectsControllerGetAreaResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerGetAreaResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}',
    ...options
});

export const v1ProjectsControllerUpdateAreaName = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerUpdateAreaNameData, ThrowOnError>): RequestResult<V1ProjectsControllerUpdateAreaNameResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1ProjectsControllerUpdateAreaNameResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ProjectsControllerAddRisks = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerAddRisksData, ThrowOnError>): RequestResult<V1ProjectsControllerAddRisksResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1ProjectsControllerAddRisksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/create-bulk-risks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ProjectsControllerDeleteRisk = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerDeleteRiskData, ThrowOnError>): RequestResult<V1ProjectsControllerDeleteRiskResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1ProjectsControllerDeleteRiskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}',
    ...options
});

export const v1ProjectsControllerGetRisk = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerGetRiskData, ThrowOnError>): RequestResult<V1ProjectsControllerGetRiskResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerGetRiskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}',
    ...options
});

export const v1ProjectsControllerUpdateRisk = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerUpdateRiskData, ThrowOnError>): RequestResult<V1ProjectsControllerUpdateRiskResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1ProjectsControllerUpdateRiskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ProjectsControllerGetRisks = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerGetRisksData, ThrowOnError>): RequestResult<V1ProjectsControllerGetRisksResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerGetRisksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks',
    ...options
});

export const v1ProjectsControllerGetSuggestedAreaTypes = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerGetSuggestedAreaTypesData, ThrowOnError>): RequestResult<V1ProjectsControllerGetSuggestedAreaTypesResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerGetSuggestedAreaTypesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/suggested-area-types',
    ...options
});

export const v1ProjectsControllerGetSuggestedRiskTypesForArea = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerGetSuggestedRiskTypesForAreaData, ThrowOnError>): RequestResult<V1ProjectsControllerGetSuggestedRiskTypesForAreaResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerGetSuggestedRiskTypesForAreaResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/suggested-risk-types',
    ...options
});

export const v1ProjectsControllerGetScenarios = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerGetScenariosData, ThrowOnError>): RequestResult<V1ProjectsControllerGetScenariosResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerGetScenariosResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios',
    ...options
});

export const v1ProjectsControllerCreateScenario = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerCreateScenarioData, ThrowOnError>): RequestResult<V1ProjectsControllerCreateScenarioResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1ProjectsControllerCreateScenarioResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ProjectsControllerCreateCustomScenario = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerCreateCustomScenarioData, ThrowOnError>): RequestResult<V1ProjectsControllerCreateCustomScenarioResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1ProjectsControllerCreateCustomScenarioResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/custom-scenarios',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ProjectsControllerDeleteScenario = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerDeleteScenarioData, ThrowOnError>): RequestResult<V1ProjectsControllerDeleteScenarioResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1ProjectsControllerDeleteScenarioResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}',
    ...options
});

export const v1ProjectsControllerGetScenario = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerGetScenarioData, ThrowOnError>): RequestResult<V1ProjectsControllerGetScenarioResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerGetScenarioResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}',
    ...options
});

export const v1ProjectsControllerUpdateScenario = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerUpdateScenarioData, ThrowOnError>): RequestResult<V1ProjectsControllerUpdateScenarioResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1ProjectsControllerUpdateScenarioResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ProjectsControllerGetSolutions = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerGetSolutionsData, ThrowOnError>): RequestResult<V1ProjectsControllerGetSolutionsResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerGetSolutionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/solutions',
    ...options
});

export const v1ProjectsControllerCreateSolution = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerCreateSolutionData, ThrowOnError>): RequestResult<V1ProjectsControllerCreateSolutionResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1ProjectsControllerCreateSolutionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/solutions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ProjectsControllerDeleteSolution = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerDeleteSolutionData, ThrowOnError>): RequestResult<V1ProjectsControllerDeleteSolutionResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1ProjectsControllerDeleteSolutionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/solutions/{solutionId}',
    ...options
});

export const v1ProjectsControllerGetSolution = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerGetSolutionData, ThrowOnError>): RequestResult<V1ProjectsControllerGetSolutionResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerGetSolutionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/solutions/{solutionId}',
    ...options
});

export const v1ProjectsControllerAddBulkSolutions = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerAddBulkSolutionsData, ThrowOnError>): RequestResult<V1ProjectsControllerAddBulkSolutionsResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1ProjectsControllerAddBulkSolutionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/create-bulk-solutions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ProjectsControllerGetSuggestedScenariosForRisk = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerGetSuggestedScenariosForRiskData, ThrowOnError>): RequestResult<V1ProjectsControllerGetSuggestedScenariosForRiskResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerGetSuggestedScenariosForRiskResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/suggested-scenario-types',
    ...options
});

export const v1ProjectsControllerGetSuggestedSolutionsForScenario = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerGetSuggestedSolutionsForScenarioData, ThrowOnError>): RequestResult<V1ProjectsControllerGetSuggestedSolutionsForScenarioResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerGetSuggestedSolutionsForScenarioResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/suggested-solution-types',
    ...options
});

export const v1ProjectsControllerDeleteProjectImage = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerDeleteProjectImageData, ThrowOnError>): RequestResult<V1ProjectsControllerDeleteProjectImageResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1ProjectsControllerDeleteProjectImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/image',
    ...options
});

export const v1ProjectsControllerGetProjectImage = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerGetProjectImageData, ThrowOnError>): RequestResult<V1ProjectsControllerGetProjectImageResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerGetProjectImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/image',
    ...options
});

export const v1ProjectsControllerAddImageToProject = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerAddImageToProjectData, ThrowOnError>): RequestResult<V1ProjectsControllerAddImageToProjectResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1ProjectsControllerAddImageToProjectResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const v1ProjectsControllerAddImageToScenario = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerAddImageToScenarioData, ThrowOnError>): RequestResult<V1ProjectsControllerAddImageToScenarioResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1ProjectsControllerAddImageToScenarioResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/images',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const v1ProjectsControllerGetScenarioImage = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerGetScenarioImageData, ThrowOnError>): RequestResult<V1ProjectsControllerGetScenarioImageResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ProjectsControllerGetScenarioImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/images/{scenarioImageId}',
    ...options
});

export const v1ProjectsControllerDeleteScenarioImage = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerDeleteScenarioImageData, ThrowOnError>): RequestResult<V1ProjectsControllerDeleteScenarioImageResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1ProjectsControllerDeleteScenarioImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/images/{imageId}',
    ...options
});

export const v1ProjectsControllerCreateCustomSolution = <ThrowOnError extends boolean = false>(options: Options<V1ProjectsControllerCreateCustomSolutionData, ThrowOnError>): RequestResult<V1ProjectsControllerCreateCustomSolutionResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1ProjectsControllerCreateCustomSolutionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{id}/areas/{areaId}/risks/{riskId}/scenarios/{scenarioId}/custom-solutions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1OpportunitiesControllerRedirectToProjectReport = <ThrowOnError extends boolean = false>(options: Options<V1OpportunitiesControllerRedirectToProjectReportData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> => (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/opportunities/{opportunityId}/redirect-to-project-report',
    ...options
});

/**
 * @deprecated
 */
export const cepApiControllerGetUserOpportunities = <ThrowOnError extends boolean = false>(options?: Options<CepApiControllerGetUserOpportunitiesData, ThrowOnError>): RequestResult<CepApiControllerGetUserOpportunitiesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CepApiControllerGetUserOpportunitiesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cep-api/opportunities',
    ...options
});

/**
 * @deprecated
 */
export const cepApiControllerGetAllAccountSites = <ThrowOnError extends boolean = false>(options: Options<CepApiControllerGetAllAccountSitesData, ThrowOnError>): RequestResult<CepApiControllerGetAllAccountSitesResponses, unknown, ThrowOnError> => (options.client ?? client).get<CepApiControllerGetAllAccountSitesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cep-api/accounts/{accountNumber}/sites',
    ...options
});

/**
 * @deprecated
 */
export const cepApiControllerGetAccountSiteDetails = <ThrowOnError extends boolean = false>(options: Options<CepApiControllerGetAccountSiteDetailsData, ThrowOnError>): RequestResult<CepApiControllerGetAccountSiteDetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<CepApiControllerGetAccountSiteDetailsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cep-api/sites/{siteNumber}',
    ...options
});

export const v1CepApiControllerGetUserOpportunities = <ThrowOnError extends boolean = false>(options?: Options<V1CepApiControllerGetUserOpportunitiesData, ThrowOnError>): RequestResult<V1CepApiControllerGetUserOpportunitiesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1CepApiControllerGetUserOpportunitiesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/cep-api/opportunities',
    ...options
});

export const v1CepApiControllerGetAllAccountSites = <ThrowOnError extends boolean = false>(options: Options<V1CepApiControllerGetAllAccountSitesData, ThrowOnError>): RequestResult<V1CepApiControllerGetAllAccountSitesResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1CepApiControllerGetAllAccountSitesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/cep-api/accounts/{accountNumber}/sites',
    ...options
});

export const v1CepApiControllerGetAccountSiteDetails = <ThrowOnError extends boolean = false>(options: Options<V1CepApiControllerGetAccountSiteDetailsData, ThrowOnError>): RequestResult<V1CepApiControllerGetAccountSiteDetailsResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1CepApiControllerGetAccountSiteDetailsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/cep-api/sites/{siteNumber}',
    ...options
});

/**
 * @deprecated
 */
export const riskValueChainControllerList = <ThrowOnError extends boolean = false>(options?: Options<RiskValueChainControllerListData, ThrowOnError>): RequestResult<RiskValueChainControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<RiskValueChainControllerListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-value-chains',
    ...options
});

/**
 * @deprecated
 */
export const riskValueChainControllerCreate = <ThrowOnError extends boolean = false>(options: Options<RiskValueChainControllerCreateData, ThrowOnError>): RequestResult<RiskValueChainControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<RiskValueChainControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-value-chains',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const riskValueChainControllerDuplicate = <ThrowOnError extends boolean = false>(options: Options<RiskValueChainControllerDuplicateData, ThrowOnError>): RequestResult<RiskValueChainControllerDuplicateResponses, unknown, ThrowOnError> => (options.client ?? client).post<RiskValueChainControllerDuplicateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-value-chains/{riskValueChainId}/duplicate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const riskValueChainControllerDelete = <ThrowOnError extends boolean = false>(options: Options<RiskValueChainControllerDeleteData, ThrowOnError>): RequestResult<RiskValueChainControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<RiskValueChainControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-value-chains/{id}',
    ...options
});

/**
 * @deprecated
 */
export const riskValueChainControllerRead = <ThrowOnError extends boolean = false>(options: Options<RiskValueChainControllerReadData, ThrowOnError>): RequestResult<RiskValueChainControllerReadResponses, unknown, ThrowOnError> => (options.client ?? client).get<RiskValueChainControllerReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-value-chains/{id}',
    ...options
});

/**
 * @deprecated
 */
export const riskValueChainControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<RiskValueChainControllerUpdateData, ThrowOnError>): RequestResult<RiskValueChainControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<RiskValueChainControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-value-chains/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const riskValueChainControllerCreateAreaTypeRecommendation = <ThrowOnError extends boolean = false>(options: Options<RiskValueChainControllerCreateAreaTypeRecommendationData, ThrowOnError>): RequestResult<RiskValueChainControllerCreateAreaTypeRecommendationResponses, unknown, ThrowOnError> => (options.client ?? client).post<RiskValueChainControllerCreateAreaTypeRecommendationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-value-chains/{id}/area-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const riskValueChainControllerDeleteAreaTypeRecommendation = <ThrowOnError extends boolean = false>(options: Options<RiskValueChainControllerDeleteAreaTypeRecommendationData, ThrowOnError>): RequestResult<RiskValueChainControllerDeleteAreaTypeRecommendationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<RiskValueChainControllerDeleteAreaTypeRecommendationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-value-chains/{id}/area-types/{areaTypeId}',
    ...options
});

/**
 * @deprecated
 */
export const riskValueChainControllerGetRiskTypeRecommendations = <ThrowOnError extends boolean = false>(options: Options<RiskValueChainControllerGetRiskTypeRecommendationsData, ThrowOnError>): RequestResult<RiskValueChainControllerGetRiskTypeRecommendationsResponses, unknown, ThrowOnError> => (options.client ?? client).get<RiskValueChainControllerGetRiskTypeRecommendationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-value-chains/{id}/area-types/{areaTypeId}/risk-types',
    ...options
});

/**
 * @deprecated
 */
export const riskValueChainControllerCreateRiskTypeRecommendation = <ThrowOnError extends boolean = false>(options: Options<RiskValueChainControllerCreateRiskTypeRecommendationData, ThrowOnError>): RequestResult<RiskValueChainControllerCreateRiskTypeRecommendationResponses, unknown, ThrowOnError> => (options.client ?? client).post<RiskValueChainControllerCreateRiskTypeRecommendationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-value-chains/{id}/area-types/{areaTypeId}/risk-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const riskValueChainControllerDeleteRiskTypeRecommendation = <ThrowOnError extends boolean = false>(options: Options<RiskValueChainControllerDeleteRiskTypeRecommendationData, ThrowOnError>): RequestResult<RiskValueChainControllerDeleteRiskTypeRecommendationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<RiskValueChainControllerDeleteRiskTypeRecommendationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-value-chains/{id}/area-types/{areaTypeId}/risk-types/{riskTypeId}',
    ...options
});

/**
 * @deprecated
 */
export const riskValueChainControllerCreateScenarioTypeRecommendation = <ThrowOnError extends boolean = false>(options: Options<RiskValueChainControllerCreateScenarioTypeRecommendationData, ThrowOnError>): RequestResult<RiskValueChainControllerCreateScenarioTypeRecommendationResponses, unknown, ThrowOnError> => (options.client ?? client).post<RiskValueChainControllerCreateScenarioTypeRecommendationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-value-chains/{id}/area-types/{areaTypeId}/risk-types/{riskTypeId}/scenario-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const riskValueChainControllerDeleteScenarioTypeRecommendation = <ThrowOnError extends boolean = false>(options: Options<RiskValueChainControllerDeleteScenarioTypeRecommendationData, ThrowOnError>): RequestResult<RiskValueChainControllerDeleteScenarioTypeRecommendationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<RiskValueChainControllerDeleteScenarioTypeRecommendationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-value-chains/{id}/area-types/{areaTypeId}/risk-types/{riskTypeId}/scenario-types/{scenarioTypeId}',
    ...options
});

/**
 * @deprecated
 */
export const riskValueChainControllerCreateSolutionTypeRecommendation = <ThrowOnError extends boolean = false>(options: Options<RiskValueChainControllerCreateSolutionTypeRecommendationData, ThrowOnError>): RequestResult<RiskValueChainControllerCreateSolutionTypeRecommendationResponses, unknown, ThrowOnError> => (options.client ?? client).post<RiskValueChainControllerCreateSolutionTypeRecommendationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-value-chains/{id}/area-types/{areaTypeId}/risk-types/{riskTypeId}/scenario-types/{scenarioTypeId}/solution-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const riskValueChainControllerDeleteSolutionTypeRecommendation = <ThrowOnError extends boolean = false>(options: Options<RiskValueChainControllerDeleteSolutionTypeRecommendationData, ThrowOnError>): RequestResult<RiskValueChainControllerDeleteSolutionTypeRecommendationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<RiskValueChainControllerDeleteSolutionTypeRecommendationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-value-chains/{id}/area-types/{areaTypeId}/risk-types/{riskTypeId}/scenario-types/{scenarioTypeId}/solution-types/{solutionTypeId}',
    ...options
});

export const v1RiskValueChainControllerList = <ThrowOnError extends boolean = false>(options?: Options<V1RiskValueChainControllerListData, ThrowOnError>): RequestResult<V1RiskValueChainControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1RiskValueChainControllerListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-value-chains',
    ...options
});

export const v1RiskValueChainControllerCreate = <ThrowOnError extends boolean = false>(options: Options<V1RiskValueChainControllerCreateData, ThrowOnError>): RequestResult<V1RiskValueChainControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1RiskValueChainControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-value-chains',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1RiskValueChainControllerDuplicate = <ThrowOnError extends boolean = false>(options: Options<V1RiskValueChainControllerDuplicateData, ThrowOnError>): RequestResult<V1RiskValueChainControllerDuplicateResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1RiskValueChainControllerDuplicateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-value-chains/{riskValueChainId}/duplicate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1RiskValueChainControllerDelete = <ThrowOnError extends boolean = false>(options: Options<V1RiskValueChainControllerDeleteData, ThrowOnError>): RequestResult<V1RiskValueChainControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1RiskValueChainControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-value-chains/{id}',
    ...options
});

export const v1RiskValueChainControllerRead = <ThrowOnError extends boolean = false>(options: Options<V1RiskValueChainControllerReadData, ThrowOnError>): RequestResult<V1RiskValueChainControllerReadResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1RiskValueChainControllerReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-value-chains/{id}',
    ...options
});

export const v1RiskValueChainControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<V1RiskValueChainControllerUpdateData, ThrowOnError>): RequestResult<V1RiskValueChainControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1RiskValueChainControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-value-chains/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1RiskValueChainControllerCreateAreaTypeRecommendation = <ThrowOnError extends boolean = false>(options: Options<V1RiskValueChainControllerCreateAreaTypeRecommendationData, ThrowOnError>): RequestResult<V1RiskValueChainControllerCreateAreaTypeRecommendationResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1RiskValueChainControllerCreateAreaTypeRecommendationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-value-chains/{id}/area-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1RiskValueChainControllerDeleteAreaTypeRecommendation = <ThrowOnError extends boolean = false>(options: Options<V1RiskValueChainControllerDeleteAreaTypeRecommendationData, ThrowOnError>): RequestResult<V1RiskValueChainControllerDeleteAreaTypeRecommendationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1RiskValueChainControllerDeleteAreaTypeRecommendationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-value-chains/{id}/area-types/{areaTypeId}',
    ...options
});

export const v1RiskValueChainControllerGetAllRiskTypeRecommendations = <ThrowOnError extends boolean = false>(options: Options<V1RiskValueChainControllerGetAllRiskTypeRecommendationsData, ThrowOnError>): RequestResult<V1RiskValueChainControllerGetAllRiskTypeRecommendationsResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1RiskValueChainControllerGetAllRiskTypeRecommendationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-value-chains/{id}/risk-type-recommendations',
    ...options
});

export const v1RiskValueChainControllerGetRiskTypeRecommendations = <ThrowOnError extends boolean = false>(options: Options<V1RiskValueChainControllerGetRiskTypeRecommendationsData, ThrowOnError>): RequestResult<V1RiskValueChainControllerGetRiskTypeRecommendationsResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1RiskValueChainControllerGetRiskTypeRecommendationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-value-chains/{id}/area-types/{areaTypeId}/risk-types',
    ...options
});

export const v1RiskValueChainControllerCreateRiskTypeRecommendation = <ThrowOnError extends boolean = false>(options: Options<V1RiskValueChainControllerCreateRiskTypeRecommendationData, ThrowOnError>): RequestResult<V1RiskValueChainControllerCreateRiskTypeRecommendationResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1RiskValueChainControllerCreateRiskTypeRecommendationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-value-chains/{id}/area-types/{areaTypeId}/risk-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1RiskValueChainControllerDeleteRiskTypeRecommendation = <ThrowOnError extends boolean = false>(options: Options<V1RiskValueChainControllerDeleteRiskTypeRecommendationData, ThrowOnError>): RequestResult<V1RiskValueChainControllerDeleteRiskTypeRecommendationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1RiskValueChainControllerDeleteRiskTypeRecommendationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-value-chains/{id}/area-types/{areaTypeId}/risk-types/{riskTypeId}',
    ...options
});

export const v1RiskValueChainControllerCreateScenarioTypeRecommendation = <ThrowOnError extends boolean = false>(options: Options<V1RiskValueChainControllerCreateScenarioTypeRecommendationData, ThrowOnError>): RequestResult<V1RiskValueChainControllerCreateScenarioTypeRecommendationResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1RiskValueChainControllerCreateScenarioTypeRecommendationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-value-chains/{id}/area-types/{areaTypeId}/risk-types/{riskTypeId}/scenario-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1RiskValueChainControllerDeleteScenarioTypeRecommendation = <ThrowOnError extends boolean = false>(options: Options<V1RiskValueChainControllerDeleteScenarioTypeRecommendationData, ThrowOnError>): RequestResult<V1RiskValueChainControllerDeleteScenarioTypeRecommendationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1RiskValueChainControllerDeleteScenarioTypeRecommendationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-value-chains/{id}/area-types/{areaTypeId}/risk-types/{riskTypeId}/scenario-types/{scenarioTypeId}',
    ...options
});

export const v1RiskValueChainControllerCreateSolutionTypeRecommendation = <ThrowOnError extends boolean = false>(options: Options<V1RiskValueChainControllerCreateSolutionTypeRecommendationData, ThrowOnError>): RequestResult<V1RiskValueChainControllerCreateSolutionTypeRecommendationResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1RiskValueChainControllerCreateSolutionTypeRecommendationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-value-chains/{id}/area-types/{areaTypeId}/risk-types/{riskTypeId}/scenario-types/{scenarioTypeId}/solution-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1RiskValueChainControllerDeleteSolutionTypeRecommendation = <ThrowOnError extends boolean = false>(options: Options<V1RiskValueChainControllerDeleteSolutionTypeRecommendationData, ThrowOnError>): RequestResult<V1RiskValueChainControllerDeleteSolutionTypeRecommendationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1RiskValueChainControllerDeleteSolutionTypeRecommendationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-value-chains/{id}/area-types/{areaTypeId}/risk-types/{riskTypeId}/scenario-types/{scenarioTypeId}/solution-types/{solutionTypeId}',
    ...options
});

/**
 * @deprecated
 */
export const definitionSetControllerList = <ThrowOnError extends boolean = false>(options?: Options<DefinitionSetControllerListData, ThrowOnError>): RequestResult<DefinitionSetControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DefinitionSetControllerListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/definition-sets',
    ...options
});

/**
 * @deprecated
 */
export const definitionSetControllerCreate = <ThrowOnError extends boolean = false>(options: Options<DefinitionSetControllerCreateData, ThrowOnError>): RequestResult<DefinitionSetControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<DefinitionSetControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/definition-sets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const definitionSetControllerDelete = <ThrowOnError extends boolean = false>(options: Options<DefinitionSetControllerDeleteData, ThrowOnError>): RequestResult<DefinitionSetControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DefinitionSetControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/definition-sets/{id}',
    ...options
});

/**
 * @deprecated
 */
export const definitionSetControllerRead = <ThrowOnError extends boolean = false>(options: Options<DefinitionSetControllerReadData, ThrowOnError>): RequestResult<DefinitionSetControllerReadResponses, unknown, ThrowOnError> => (options.client ?? client).get<DefinitionSetControllerReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/definition-sets/{id}',
    ...options
});

/**
 * Update a definition set
 *
 * @deprecated
 */
export const definitionSetControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<DefinitionSetControllerUpdateData, ThrowOnError>): RequestResult<DefinitionSetControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<DefinitionSetControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/definition-sets/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const definitionSetControllerCreateDefinition = <ThrowOnError extends boolean = false>(options: Options<DefinitionSetControllerCreateDefinitionData, ThrowOnError>): RequestResult<DefinitionSetControllerCreateDefinitionResponses, unknown, ThrowOnError> => (options.client ?? client).post<DefinitionSetControllerCreateDefinitionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/definition-sets/{id}/definitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const definitionControllerDelete = <ThrowOnError extends boolean = false>(options: Options<DefinitionControllerDeleteData, ThrowOnError>): RequestResult<DefinitionControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DefinitionControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/definitions/{id}',
    ...options
});

/**
 * @deprecated
 */
export const definitionControllerRead = <ThrowOnError extends boolean = false>(options: Options<DefinitionControllerReadData, ThrowOnError>): RequestResult<DefinitionControllerReadResponses, unknown, ThrowOnError> => (options.client ?? client).get<DefinitionControllerReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/definitions/{id}',
    ...options
});

/**
 * Update a definition composed of a probability and impact definition.       Note: Properties are marked as mandatory, but are optional. Referenced properties       mutate the existing object. The remainder is preserved.
 *
 * @deprecated
 */
export const definitionControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<DefinitionControllerUpdateData, ThrowOnError>): RequestResult<DefinitionControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<DefinitionControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/definitions/{id}',
    ...options
});

export const v1DefinitionSetControllerList = <ThrowOnError extends boolean = false>(options?: Options<V1DefinitionSetControllerListData, ThrowOnError>): RequestResult<V1DefinitionSetControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1DefinitionSetControllerListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/definition-sets',
    ...options
});

export const v1DefinitionSetControllerCreate = <ThrowOnError extends boolean = false>(options: Options<V1DefinitionSetControllerCreateData, ThrowOnError>): RequestResult<V1DefinitionSetControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1DefinitionSetControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/definition-sets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1DefinitionSetControllerDelete = <ThrowOnError extends boolean = false>(options: Options<V1DefinitionSetControllerDeleteData, ThrowOnError>): RequestResult<V1DefinitionSetControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1DefinitionSetControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/definition-sets/{id}',
    ...options
});

export const v1DefinitionSetControllerRead = <ThrowOnError extends boolean = false>(options: Options<V1DefinitionSetControllerReadData, ThrowOnError>): RequestResult<V1DefinitionSetControllerReadResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1DefinitionSetControllerReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/definition-sets/{id}',
    ...options
});

/**
 * Update a definition set
 *
 * Update a definition set
 */
export const v1DefinitionSetControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<V1DefinitionSetControllerUpdateData, ThrowOnError>): RequestResult<V1DefinitionSetControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).put<V1DefinitionSetControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/definition-sets/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1DefinitionSetControllerCreateDefinition = <ThrowOnError extends boolean = false>(options: Options<V1DefinitionSetControllerCreateDefinitionData, ThrowOnError>): RequestResult<V1DefinitionSetControllerCreateDefinitionResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1DefinitionSetControllerCreateDefinitionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/definition-sets/{id}/definitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1DefinitionControllerDelete = <ThrowOnError extends boolean = false>(options: Options<V1DefinitionControllerDeleteData, ThrowOnError>): RequestResult<V1DefinitionControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1DefinitionControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/definitions/{id}',
    ...options
});

export const v1DefinitionControllerRead = <ThrowOnError extends boolean = false>(options: Options<V1DefinitionControllerReadData, ThrowOnError>): RequestResult<V1DefinitionControllerReadResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1DefinitionControllerReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/definitions/{id}',
    ...options
});

/**
 * Update a definition
 *
 * Update a definition composed of a probability and impact definition.       Note: Properties are marked as mandatory, but are optional. Referenced properties       mutate the existing object. The remainder is preserved.
 */
export const v1DefinitionControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<V1DefinitionControllerUpdateData, ThrowOnError>): RequestResult<V1DefinitionControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1DefinitionControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/definitions/{id}',
    ...options
});

/**
 * @deprecated
 */
export const userControllerGetMyUser = <ThrowOnError extends boolean = false>(options?: Options<UserControllerGetMyUserData, ThrowOnError>): RequestResult<UserControllerGetMyUserResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UserControllerGetMyUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/me',
    ...options
});

/**
 * @deprecated
 */
export const userControllerSetUserLanguage = <ThrowOnError extends boolean = false>(options: Options<UserControllerSetUserLanguageData, ThrowOnError>): RequestResult<UserControllerSetUserLanguageResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UserControllerSetUserLanguageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/me/language',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const userControllerGetMyUserRoles = <ThrowOnError extends boolean = false>(options?: Options<UserControllerGetMyUserRolesData, ThrowOnError>): RequestResult<UserControllerGetMyUserRolesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UserControllerGetMyUserRolesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/me/roles',
    ...options
});

/**
 * @deprecated
 */
export const userControllerGetMyUserWorkspaces = <ThrowOnError extends boolean = false>(options?: Options<UserControllerGetMyUserWorkspacesData, ThrowOnError>): RequestResult<UserControllerGetMyUserWorkspacesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UserControllerGetMyUserWorkspacesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/me/workspaces',
    ...options
});

/**
 * @deprecated
 */
export const userControllerGetAllRoles = <ThrowOnError extends boolean = false>(options?: Options<UserControllerGetAllRolesData, ThrowOnError>): RequestResult<UserControllerGetAllRolesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UserControllerGetAllRolesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/roles',
    ...options
});

/**
 * @deprecated
 */
export const userControllerGetAllUsers = <ThrowOnError extends boolean = false>(options?: Options<UserControllerGetAllUsersData, ThrowOnError>): RequestResult<UserControllerGetAllUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UserControllerGetAllUsersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users',
    ...options
});

/**
 * @deprecated
 */
export const userControllerGetUserByEmail = <ThrowOnError extends boolean = false>(options: Options<UserControllerGetUserByEmailData, ThrowOnError>): RequestResult<UserControllerGetUserByEmailResponses, unknown, ThrowOnError> => (options.client ?? client).get<UserControllerGetUserByEmailResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/email/{email}',
    ...options
});

/**
 * @deprecated
 */
export const userControllerGetUserByEntraId = <ThrowOnError extends boolean = false>(options: Options<UserControllerGetUserByEntraIdData, ThrowOnError>): RequestResult<UserControllerGetUserByEntraIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<UserControllerGetUserByEntraIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/entra-id/{entraIdOid}',
    ...options
});

/**
 * @deprecated
 */
export const userControllerGetUserById = <ThrowOnError extends boolean = false>(options: Options<UserControllerGetUserByIdData, ThrowOnError>): RequestResult<UserControllerGetUserByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<UserControllerGetUserByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{userId}',
    ...options
});

/**
 * @deprecated
 */
export const userControllerUpdateUser = <ThrowOnError extends boolean = false>(options: Options<UserControllerUpdateUserData, ThrowOnError>): RequestResult<UserControllerUpdateUserResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UserControllerUpdateUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{userId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1UserControllerGetMyUser = <ThrowOnError extends boolean = false>(options?: Options<V1UserControllerGetMyUserData, ThrowOnError>): RequestResult<V1UserControllerGetMyUserResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1UserControllerGetMyUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/me',
    ...options
});

export const v1UserControllerSetUserLanguage = <ThrowOnError extends boolean = false>(options: Options<V1UserControllerSetUserLanguageData, ThrowOnError>): RequestResult<V1UserControllerSetUserLanguageResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1UserControllerSetUserLanguageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/me/language',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1UserControllerGetMyUserRoles = <ThrowOnError extends boolean = false>(options?: Options<V1UserControllerGetMyUserRolesData, ThrowOnError>): RequestResult<V1UserControllerGetMyUserRolesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1UserControllerGetMyUserRolesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/me/roles',
    ...options
});

export const v1UserControllerGetMyUserWorkspaces = <ThrowOnError extends boolean = false>(options?: Options<V1UserControllerGetMyUserWorkspacesData, ThrowOnError>): RequestResult<V1UserControllerGetMyUserWorkspacesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1UserControllerGetMyUserWorkspacesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/me/workspaces',
    ...options
});

export const v1UserControllerGetAllRoles = <ThrowOnError extends boolean = false>(options?: Options<V1UserControllerGetAllRolesData, ThrowOnError>): RequestResult<V1UserControllerGetAllRolesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1UserControllerGetAllRolesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/roles',
    ...options
});

export const v1UserControllerGetAllUsers = <ThrowOnError extends boolean = false>(options?: Options<V1UserControllerGetAllUsersData, ThrowOnError>): RequestResult<V1UserControllerGetAllUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1UserControllerGetAllUsersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users',
    ...options
});

export const v1UserControllerGetUserByEmail = <ThrowOnError extends boolean = false>(options: Options<V1UserControllerGetUserByEmailData, ThrowOnError>): RequestResult<V1UserControllerGetUserByEmailResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1UserControllerGetUserByEmailResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/email/{email}',
    ...options
});

export const v1UserControllerGetUserByEntraId = <ThrowOnError extends boolean = false>(options: Options<V1UserControllerGetUserByEntraIdData, ThrowOnError>): RequestResult<V1UserControllerGetUserByEntraIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1UserControllerGetUserByEntraIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/entra-id/{entraIdOid}',
    ...options
});

export const v1UserControllerGetUserById = <ThrowOnError extends boolean = false>(options: Options<V1UserControllerGetUserByIdData, ThrowOnError>): RequestResult<V1UserControllerGetUserByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1UserControllerGetUserByIdResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/{userId}',
    ...options
});

export const v1UserControllerUpdateUser = <ThrowOnError extends boolean = false>(options: Options<V1UserControllerUpdateUserData, ThrowOnError>): RequestResult<V1UserControllerUpdateUserResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1UserControllerUpdateUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/{userId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const localizationControllerGetAllLanguages = <ThrowOnError extends boolean = false>(options?: Options<LocalizationControllerGetAllLanguagesData, ThrowOnError>): RequestResult<LocalizationControllerGetAllLanguagesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<LocalizationControllerGetAllLanguagesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/languages',
    ...options
});

/**
 * @deprecated
 */
export const localizationControllerCreateLanguage = <ThrowOnError extends boolean = false>(options: Options<LocalizationControllerCreateLanguageData, ThrowOnError>): RequestResult<LocalizationControllerCreateLanguageResponses, unknown, ThrowOnError> => (options.client ?? client).post<LocalizationControllerCreateLanguageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/languages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const localizationControllerDeleteTranslation = <ThrowOnError extends boolean = false>(options: Options<LocalizationControllerDeleteTranslationData, ThrowOnError>): RequestResult<LocalizationControllerDeleteTranslationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<LocalizationControllerDeleteTranslationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/languages/{languageId}/translations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const localizationControllerGetAllTranslations = <ThrowOnError extends boolean = false>(options: Options<LocalizationControllerGetAllTranslationsData, ThrowOnError>): RequestResult<LocalizationControllerGetAllTranslationsResponses, unknown, ThrowOnError> => (options.client ?? client).get<LocalizationControllerGetAllTranslationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/languages/{languageId}/translations',
    ...options
});

/**
 * @deprecated
 */
export const localizationControllerUpdateTranslation = <ThrowOnError extends boolean = false>(options: Options<LocalizationControllerUpdateTranslationData, ThrowOnError>): RequestResult<LocalizationControllerUpdateTranslationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<LocalizationControllerUpdateTranslationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/languages/{languageId}/translations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const localizationControllerCreateTranslation = <ThrowOnError extends boolean = false>(options: Options<LocalizationControllerCreateTranslationData, ThrowOnError>): RequestResult<LocalizationControllerCreateTranslationResponses, unknown, ThrowOnError> => (options.client ?? client).post<LocalizationControllerCreateTranslationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/languages/{languageId}/translations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const localizationControllerBulkCreateTranslations = <ThrowOnError extends boolean = false>(options: Options<LocalizationControllerBulkCreateTranslationsData, ThrowOnError>): RequestResult<LocalizationControllerBulkCreateTranslationsResponses, unknown, ThrowOnError> => (options.client ?? client).post<LocalizationControllerBulkCreateTranslationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/languages/{languageId}/translations/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const localizationControllerGetAllOriginalStrings = <ThrowOnError extends boolean = false>(options?: Options<LocalizationControllerGetAllOriginalStringsData, ThrowOnError>): RequestResult<LocalizationControllerGetAllOriginalStringsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<LocalizationControllerGetAllOriginalStringsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/languages/original-strings',
    ...options
});

/**
 * @deprecated
 */
export const localizationControllerGetLanguageProgress = <ThrowOnError extends boolean = false>(options?: Options<LocalizationControllerGetLanguageProgressData, ThrowOnError>): RequestResult<LocalizationControllerGetLanguageProgressResponses, unknown, ThrowOnError> => (options?.client ?? client).get<LocalizationControllerGetLanguageProgressResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/languages/progress',
    ...options
});

/**
 * @deprecated
 */
export const localizationControllerTranslateText = <ThrowOnError extends boolean = false>(options: Options<LocalizationControllerTranslateTextData, ThrowOnError>): RequestResult<LocalizationControllerTranslateTextResponses, unknown, ThrowOnError> => (options.client ?? client).post<LocalizationControllerTranslateTextResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/translate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const localizationControllerDeleteUiLocalization = <ThrowOnError extends boolean = false>(options: Options<LocalizationControllerDeleteUiLocalizationData, ThrowOnError>): RequestResult<LocalizationControllerDeleteUiLocalizationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<LocalizationControllerDeleteUiLocalizationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/languages/{locale}/ui-localizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const localizationControllerGetUiLocalizations = <ThrowOnError extends boolean = false>(options: Options<LocalizationControllerGetUiLocalizationsData, ThrowOnError>): RequestResult<LocalizationControllerGetUiLocalizationsResponses, unknown, ThrowOnError> => (options.client ?? client).get<LocalizationControllerGetUiLocalizationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/languages/{locale}/ui-localizations',
    ...options
});

/**
 * @deprecated
 */
export const localizationControllerUpdateUiLocalization = <ThrowOnError extends boolean = false>(options: Options<LocalizationControllerUpdateUiLocalizationData, ThrowOnError>): RequestResult<LocalizationControllerUpdateUiLocalizationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<LocalizationControllerUpdateUiLocalizationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/languages/{locale}/ui-localizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const localizationControllerCreateUiLocalization = <ThrowOnError extends boolean = false>(options: Options<LocalizationControllerCreateUiLocalizationData, ThrowOnError>): RequestResult<LocalizationControllerCreateUiLocalizationResponses, unknown, ThrowOnError> => (options.client ?? client).post<LocalizationControllerCreateUiLocalizationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/languages/{locale}/ui-localizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const localizationControllerBulkCreateUiLocalizations = <ThrowOnError extends boolean = false>(options: Options<LocalizationControllerBulkCreateUiLocalizationsData, ThrowOnError>): RequestResult<LocalizationControllerBulkCreateUiLocalizationsResponses, unknown, ThrowOnError> => (options.client ?? client).post<LocalizationControllerBulkCreateUiLocalizationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/languages/{locale}/ui-localizations/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1LocalizationControllerGetAllLanguages = <ThrowOnError extends boolean = false>(options?: Options<V1LocalizationControllerGetAllLanguagesData, ThrowOnError>): RequestResult<V1LocalizationControllerGetAllLanguagesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1LocalizationControllerGetAllLanguagesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/languages',
    ...options
});

export const v1LocalizationControllerCreateLanguage = <ThrowOnError extends boolean = false>(options: Options<V1LocalizationControllerCreateLanguageData, ThrowOnError>): RequestResult<V1LocalizationControllerCreateLanguageResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1LocalizationControllerCreateLanguageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/languages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1LocalizationControllerDeleteTranslation = <ThrowOnError extends boolean = false>(options: Options<V1LocalizationControllerDeleteTranslationData, ThrowOnError>): RequestResult<V1LocalizationControllerDeleteTranslationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1LocalizationControllerDeleteTranslationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/languages/{languageId}/translations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1LocalizationControllerGetAllTranslations = <ThrowOnError extends boolean = false>(options: Options<V1LocalizationControllerGetAllTranslationsData, ThrowOnError>): RequestResult<V1LocalizationControllerGetAllTranslationsResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1LocalizationControllerGetAllTranslationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/languages/{languageId}/translations',
    ...options
});

export const v1LocalizationControllerUpdateTranslation = <ThrowOnError extends boolean = false>(options: Options<V1LocalizationControllerUpdateTranslationData, ThrowOnError>): RequestResult<V1LocalizationControllerUpdateTranslationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1LocalizationControllerUpdateTranslationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/languages/{languageId}/translations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1LocalizationControllerCreateTranslation = <ThrowOnError extends boolean = false>(options: Options<V1LocalizationControllerCreateTranslationData, ThrowOnError>): RequestResult<V1LocalizationControllerCreateTranslationResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1LocalizationControllerCreateTranslationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/languages/{languageId}/translations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1LocalizationControllerBulkCreateTranslations = <ThrowOnError extends boolean = false>(options: Options<V1LocalizationControllerBulkCreateTranslationsData, ThrowOnError>): RequestResult<V1LocalizationControllerBulkCreateTranslationsResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1LocalizationControllerBulkCreateTranslationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/languages/{languageId}/translations/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1LocalizationControllerGetAllOriginalStrings = <ThrowOnError extends boolean = false>(options?: Options<V1LocalizationControllerGetAllOriginalStringsData, ThrowOnError>): RequestResult<V1LocalizationControllerGetAllOriginalStringsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1LocalizationControllerGetAllOriginalStringsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/languages/original-strings',
    ...options
});

export const v1LocalizationControllerGetLanguageProgress = <ThrowOnError extends boolean = false>(options?: Options<V1LocalizationControllerGetLanguageProgressData, ThrowOnError>): RequestResult<V1LocalizationControllerGetLanguageProgressResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1LocalizationControllerGetLanguageProgressResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/languages/progress',
    ...options
});

export const v1LocalizationControllerTranslateText = <ThrowOnError extends boolean = false>(options: Options<V1LocalizationControllerTranslateTextData, ThrowOnError>): RequestResult<V1LocalizationControllerTranslateTextResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1LocalizationControllerTranslateTextResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/translate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1LocalizationControllerDeleteUiLocalization = <ThrowOnError extends boolean = false>(options: Options<V1LocalizationControllerDeleteUiLocalizationData, ThrowOnError>): RequestResult<V1LocalizationControllerDeleteUiLocalizationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1LocalizationControllerDeleteUiLocalizationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/languages/{locale}/ui-localizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1LocalizationControllerGetUiLocalizations = <ThrowOnError extends boolean = false>(options: Options<V1LocalizationControllerGetUiLocalizationsData, ThrowOnError>): RequestResult<V1LocalizationControllerGetUiLocalizationsResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1LocalizationControllerGetUiLocalizationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/languages/{locale}/ui-localizations',
    ...options
});

export const v1LocalizationControllerUpdateUiLocalization = <ThrowOnError extends boolean = false>(options: Options<V1LocalizationControllerUpdateUiLocalizationData, ThrowOnError>): RequestResult<V1LocalizationControllerUpdateUiLocalizationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1LocalizationControllerUpdateUiLocalizationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/languages/{locale}/ui-localizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1LocalizationControllerCreateUiLocalization = <ThrowOnError extends boolean = false>(options: Options<V1LocalizationControllerCreateUiLocalizationData, ThrowOnError>): RequestResult<V1LocalizationControllerCreateUiLocalizationResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1LocalizationControllerCreateUiLocalizationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/languages/{locale}/ui-localizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1LocalizationControllerBulkCreateUiLocalizations = <ThrowOnError extends boolean = false>(options: Options<V1LocalizationControllerBulkCreateUiLocalizationsData, ThrowOnError>): RequestResult<V1LocalizationControllerBulkCreateUiLocalizationsResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1LocalizationControllerBulkCreateUiLocalizationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/languages/{locale}/ui-localizations/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const workspacesControllerFindAll = <ThrowOnError extends boolean = false>(options?: Options<WorkspacesControllerFindAllData, ThrowOnError>): RequestResult<WorkspacesControllerFindAllResponses, unknown, ThrowOnError> => (options?.client ?? client).get<WorkspacesControllerFindAllResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces',
    ...options
});

/**
 * @deprecated
 */
export const workspacesControllerCreate = <ThrowOnError extends boolean = false>(options: Options<WorkspacesControllerCreateData, ThrowOnError>): RequestResult<WorkspacesControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<WorkspacesControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const workspacesControllerFindAllOverview = <ThrowOnError extends boolean = false>(options?: Options<WorkspacesControllerFindAllOverviewData, ThrowOnError>): RequestResult<WorkspacesControllerFindAllOverviewResponses, unknown, ThrowOnError> => (options?.client ?? client).get<WorkspacesControllerFindAllOverviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/overview',
    ...options
});

/**
 * @deprecated
 */
export const workspacesControllerDelete = <ThrowOnError extends boolean = false>(options: Options<WorkspacesControllerDeleteData, ThrowOnError>): RequestResult<WorkspacesControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<WorkspacesControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/{id}',
    ...options
});

/**
 * @deprecated
 */
export const workspacesControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<WorkspacesControllerUpdateData, ThrowOnError>): RequestResult<WorkspacesControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<WorkspacesControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const workspacesControllerAddAdministrator = <ThrowOnError extends boolean = false>(options: Options<WorkspacesControllerAddAdministratorData, ThrowOnError>): RequestResult<WorkspacesControllerAddAdministratorResponses, unknown, ThrowOnError> => (options.client ?? client).post<WorkspacesControllerAddAdministratorResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/{id}/administrator',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const workspacesControllerRemoveAdministrator = <ThrowOnError extends boolean = false>(options: Options<WorkspacesControllerRemoveAdministratorData, ThrowOnError>): RequestResult<WorkspacesControllerRemoveAdministratorResponses, unknown, ThrowOnError> => (options.client ?? client).delete<WorkspacesControllerRemoveAdministratorResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/{id}/administrator/{userId}',
    ...options
});

/**
 * @deprecated
 */
export const workspacesControllerAddMember = <ThrowOnError extends boolean = false>(options: Options<WorkspacesControllerAddMemberData, ThrowOnError>): RequestResult<WorkspacesControllerAddMemberResponses, unknown, ThrowOnError> => (options.client ?? client).post<WorkspacesControllerAddMemberResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/{id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const workspacesControllerUpdateMember = <ThrowOnError extends boolean = false>(options: Options<WorkspacesControllerUpdateMemberData, ThrowOnError>): RequestResult<WorkspacesControllerUpdateMemberResponses, unknown, ThrowOnError> => (options.client ?? client).put<WorkspacesControllerUpdateMemberResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/{id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const workspacesControllerRemoveMember = <ThrowOnError extends boolean = false>(options: Options<WorkspacesControllerRemoveMemberData, ThrowOnError>): RequestResult<WorkspacesControllerRemoveMemberResponses, unknown, ThrowOnError> => (options.client ?? client).delete<WorkspacesControllerRemoveMemberResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/{id}/members/{userId}',
    ...options
});

/**
 * @deprecated
 */
export const workspacesControllerGetWorkspaceAssociatedRiskValueChains = <ThrowOnError extends boolean = false>(options: Options<WorkspacesControllerGetWorkspaceAssociatedRiskValueChainsData, ThrowOnError>): RequestResult<WorkspacesControllerGetWorkspaceAssociatedRiskValueChainsResponses, unknown, ThrowOnError> => (options.client ?? client).get<WorkspacesControllerGetWorkspaceAssociatedRiskValueChainsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/{id}/risk-value-chains/associated',
    ...options
});

/**
 * @deprecated
 */
export const workspacesControllerAssociateRiskValueChain = <ThrowOnError extends boolean = false>(options: Options<WorkspacesControllerAssociateRiskValueChainData, ThrowOnError>): RequestResult<WorkspacesControllerAssociateRiskValueChainResponses, unknown, ThrowOnError> => (options.client ?? client).patch<WorkspacesControllerAssociateRiskValueChainResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/{id}/risk-value-chains/associated',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const workspacesControllerUpdateRiskValueChainAssociations = <ThrowOnError extends boolean = false>(options: Options<WorkspacesControllerUpdateRiskValueChainAssociationsData, ThrowOnError>): RequestResult<WorkspacesControllerUpdateRiskValueChainAssociationsResponses, unknown, ThrowOnError> => (options.client ?? client).put<WorkspacesControllerUpdateRiskValueChainAssociationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/{id}/risk-value-chains/associated',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const workspacesControllerDisassociateRiskValueChain = <ThrowOnError extends boolean = false>(options: Options<WorkspacesControllerDisassociateRiskValueChainData, ThrowOnError>): RequestResult<WorkspacesControllerDisassociateRiskValueChainResponses, unknown, ThrowOnError> => (options.client ?? client).delete<WorkspacesControllerDisassociateRiskValueChainResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/{id}/risk-value-chains/associated/{riskValueChainId}',
    ...options
});

/**
 * @deprecated
 */
export const workspacesControllerGetWorkspaceAvailableRiskValueChains = <ThrowOnError extends boolean = false>(options: Options<WorkspacesControllerGetWorkspaceAvailableRiskValueChainsData, ThrowOnError>): RequestResult<WorkspacesControllerGetWorkspaceAvailableRiskValueChainsResponses, unknown, ThrowOnError> => (options.client ?? client).get<WorkspacesControllerGetWorkspaceAvailableRiskValueChainsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/{id}/risk-value-chains/available',
    ...options
});

/**
 * @deprecated
 */
export const workspacesControllerGetWorkspaceAssociatedSolutionTypes = <ThrowOnError extends boolean = false>(options: Options<WorkspacesControllerGetWorkspaceAssociatedSolutionTypesData, ThrowOnError>): RequestResult<WorkspacesControllerGetWorkspaceAssociatedSolutionTypesResponses, unknown, ThrowOnError> => (options.client ?? client).get<WorkspacesControllerGetWorkspaceAssociatedSolutionTypesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/{id}/solution-types/associated',
    ...options
});

/**
 * @deprecated
 */
export const workspacesControllerUpdateSolutionTypeAssociations = <ThrowOnError extends boolean = false>(options: Options<WorkspacesControllerUpdateSolutionTypeAssociationsData, ThrowOnError>): RequestResult<WorkspacesControllerUpdateSolutionTypeAssociationsResponses, unknown, ThrowOnError> => (options.client ?? client).put<WorkspacesControllerUpdateSolutionTypeAssociationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/{id}/solution-types/associated',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const workspacesControllerGetWorkspaceAvailableSolutionTypes = <ThrowOnError extends boolean = false>(options: Options<WorkspacesControllerGetWorkspaceAvailableSolutionTypesData, ThrowOnError>): RequestResult<WorkspacesControllerGetWorkspaceAvailableSolutionTypesResponses, unknown, ThrowOnError> => (options.client ?? client).get<WorkspacesControllerGetWorkspaceAvailableSolutionTypesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/workspaces/{id}/solution-types/available',
    ...options
});

export const v1WorkspacesControllerFindAll = <ThrowOnError extends boolean = false>(options?: Options<V1WorkspacesControllerFindAllData, ThrowOnError>): RequestResult<V1WorkspacesControllerFindAllResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1WorkspacesControllerFindAllResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces',
    ...options
});

export const v1WorkspacesControllerCreate = <ThrowOnError extends boolean = false>(options: Options<V1WorkspacesControllerCreateData, ThrowOnError>): RequestResult<V1WorkspacesControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1WorkspacesControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1WorkspacesControllerFindAllOverview = <ThrowOnError extends boolean = false>(options?: Options<V1WorkspacesControllerFindAllOverviewData, ThrowOnError>): RequestResult<V1WorkspacesControllerFindAllOverviewResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1WorkspacesControllerFindAllOverviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/overview',
    ...options
});

export const v1WorkspacesControllerDelete = <ThrowOnError extends boolean = false>(options: Options<V1WorkspacesControllerDeleteData, ThrowOnError>): RequestResult<V1WorkspacesControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1WorkspacesControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}',
    ...options
});

export const v1WorkspacesControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<V1WorkspacesControllerUpdateData, ThrowOnError>): RequestResult<V1WorkspacesControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1WorkspacesControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1WorkspacesControllerAddAdministrator = <ThrowOnError extends boolean = false>(options: Options<V1WorkspacesControllerAddAdministratorData, ThrowOnError>): RequestResult<V1WorkspacesControllerAddAdministratorResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1WorkspacesControllerAddAdministratorResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}/administrator',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1WorkspacesControllerRemoveAdministrator = <ThrowOnError extends boolean = false>(options: Options<V1WorkspacesControllerRemoveAdministratorData, ThrowOnError>): RequestResult<V1WorkspacesControllerRemoveAdministratorResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1WorkspacesControllerRemoveAdministratorResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}/administrator/{userId}',
    ...options
});

export const v1WorkspacesControllerAddMember = <ThrowOnError extends boolean = false>(options: Options<V1WorkspacesControllerAddMemberData, ThrowOnError>): RequestResult<V1WorkspacesControllerAddMemberResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1WorkspacesControllerAddMemberResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1WorkspacesControllerUpdateMember = <ThrowOnError extends boolean = false>(options: Options<V1WorkspacesControllerUpdateMemberData, ThrowOnError>): RequestResult<V1WorkspacesControllerUpdateMemberResponses, unknown, ThrowOnError> => (options.client ?? client).put<V1WorkspacesControllerUpdateMemberResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1WorkspacesControllerRemoveMember = <ThrowOnError extends boolean = false>(options: Options<V1WorkspacesControllerRemoveMemberData, ThrowOnError>): RequestResult<V1WorkspacesControllerRemoveMemberResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1WorkspacesControllerRemoveMemberResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}/members/{userId}',
    ...options
});

export const v1WorkspacesControllerGetWorkspaceAssociatedRiskValueChains = <ThrowOnError extends boolean = false>(options: Options<V1WorkspacesControllerGetWorkspaceAssociatedRiskValueChainsData, ThrowOnError>): RequestResult<V1WorkspacesControllerGetWorkspaceAssociatedRiskValueChainsResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1WorkspacesControllerGetWorkspaceAssociatedRiskValueChainsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}/risk-value-chains/associated',
    ...options
});

export const v1WorkspacesControllerAssociateRiskValueChain = <ThrowOnError extends boolean = false>(options: Options<V1WorkspacesControllerAssociateRiskValueChainData, ThrowOnError>): RequestResult<V1WorkspacesControllerAssociateRiskValueChainResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1WorkspacesControllerAssociateRiskValueChainResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}/risk-value-chains/associated',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1WorkspacesControllerUpdateRiskValueChainAssociations = <ThrowOnError extends boolean = false>(options: Options<V1WorkspacesControllerUpdateRiskValueChainAssociationsData, ThrowOnError>): RequestResult<V1WorkspacesControllerUpdateRiskValueChainAssociationsResponses, unknown, ThrowOnError> => (options.client ?? client).put<V1WorkspacesControllerUpdateRiskValueChainAssociationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}/risk-value-chains/associated',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1WorkspacesControllerDisassociateRiskValueChain = <ThrowOnError extends boolean = false>(options: Options<V1WorkspacesControllerDisassociateRiskValueChainData, ThrowOnError>): RequestResult<V1WorkspacesControllerDisassociateRiskValueChainResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1WorkspacesControllerDisassociateRiskValueChainResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}/risk-value-chains/associated/{riskValueChainId}',
    ...options
});

export const v1WorkspacesControllerGetWorkspaceAvailableRiskValueChains = <ThrowOnError extends boolean = false>(options: Options<V1WorkspacesControllerGetWorkspaceAvailableRiskValueChainsData, ThrowOnError>): RequestResult<V1WorkspacesControllerGetWorkspaceAvailableRiskValueChainsResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1WorkspacesControllerGetWorkspaceAvailableRiskValueChainsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}/risk-value-chains/available',
    ...options
});

export const v1WorkspacesControllerGetWorkspaceAssociatedSolutionTypes = <ThrowOnError extends boolean = false>(options: Options<V1WorkspacesControllerGetWorkspaceAssociatedSolutionTypesData, ThrowOnError>): RequestResult<V1WorkspacesControllerGetWorkspaceAssociatedSolutionTypesResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1WorkspacesControllerGetWorkspaceAssociatedSolutionTypesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}/solution-types/associated',
    ...options
});

export const v1WorkspacesControllerUpdateSolutionTypeAssociations = <ThrowOnError extends boolean = false>(options: Options<V1WorkspacesControllerUpdateSolutionTypeAssociationsData, ThrowOnError>): RequestResult<V1WorkspacesControllerUpdateSolutionTypeAssociationsResponses, unknown, ThrowOnError> => (options.client ?? client).put<V1WorkspacesControllerUpdateSolutionTypeAssociationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}/solution-types/associated',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1WorkspacesControllerGetWorkspaceAvailableSolutionTypes = <ThrowOnError extends boolean = false>(options: Options<V1WorkspacesControllerGetWorkspaceAvailableSolutionTypesData, ThrowOnError>): RequestResult<V1WorkspacesControllerGetWorkspaceAvailableSolutionTypesResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1WorkspacesControllerGetWorkspaceAvailableSolutionTypesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/workspaces/{id}/solution-types/available',
    ...options
});

/**
 * @deprecated
 */
export const areaTypeControllerList = <ThrowOnError extends boolean = false>(options?: Options<AreaTypeControllerListData, ThrowOnError>): RequestResult<AreaTypeControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AreaTypeControllerListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/area-types',
    ...options
});

/**
 * @deprecated
 */
export const areaTypeControllerCreate = <ThrowOnError extends boolean = false>(options: Options<AreaTypeControllerCreateData, ThrowOnError>): RequestResult<AreaTypeControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<AreaTypeControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/area-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const areaTypeControllerDelete = <ThrowOnError extends boolean = false>(options: Options<AreaTypeControllerDeleteData, ThrowOnError>): RequestResult<AreaTypeControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<AreaTypeControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/area-types/{id}',
    ...options
});

/**
 * @deprecated
 */
export const areaTypeControllerRead = <ThrowOnError extends boolean = false>(options: Options<AreaTypeControllerReadData, ThrowOnError>): RequestResult<AreaTypeControllerReadResponses, unknown, ThrowOnError> => (options.client ?? client).get<AreaTypeControllerReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/area-types/{id}',
    ...options
});

/**
 * @deprecated
 */
export const areaTypeControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<AreaTypeControllerUpdateData, ThrowOnError>): RequestResult<AreaTypeControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<AreaTypeControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/area-types/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1AreaTypeControllerList = <ThrowOnError extends boolean = false>(options?: Options<V1AreaTypeControllerListData, ThrowOnError>): RequestResult<V1AreaTypeControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1AreaTypeControllerListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/area-types',
    ...options
});

export const v1AreaTypeControllerCreate = <ThrowOnError extends boolean = false>(options: Options<V1AreaTypeControllerCreateData, ThrowOnError>): RequestResult<V1AreaTypeControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1AreaTypeControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/area-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1AreaTypeControllerDelete = <ThrowOnError extends boolean = false>(options: Options<V1AreaTypeControllerDeleteData, ThrowOnError>): RequestResult<V1AreaTypeControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1AreaTypeControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/area-types/{id}',
    ...options
});

export const v1AreaTypeControllerRead = <ThrowOnError extends boolean = false>(options: Options<V1AreaTypeControllerReadData, ThrowOnError>): RequestResult<V1AreaTypeControllerReadResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1AreaTypeControllerReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/area-types/{id}',
    ...options
});

export const v1AreaTypeControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<V1AreaTypeControllerUpdateData, ThrowOnError>): RequestResult<V1AreaTypeControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1AreaTypeControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/area-types/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const riskTypeControllerList = <ThrowOnError extends boolean = false>(options?: Options<RiskTypeControllerListData, ThrowOnError>): RequestResult<RiskTypeControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<RiskTypeControllerListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-types',
    ...options
});

/**
 * @deprecated
 */
export const riskTypeControllerCreate = <ThrowOnError extends boolean = false>(options: Options<RiskTypeControllerCreateData, ThrowOnError>): RequestResult<RiskTypeControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<RiskTypeControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const riskTypeControllerDelete = <ThrowOnError extends boolean = false>(options: Options<RiskTypeControllerDeleteData, ThrowOnError>): RequestResult<RiskTypeControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<RiskTypeControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-types/{id}',
    ...options
});

/**
 * @deprecated
 */
export const riskTypeControllerRead = <ThrowOnError extends boolean = false>(options: Options<RiskTypeControllerReadData, ThrowOnError>): RequestResult<RiskTypeControllerReadResponses, unknown, ThrowOnError> => (options.client ?? client).get<RiskTypeControllerReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-types/{id}',
    ...options
});

/**
 * @deprecated
 */
export const riskTypeControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<RiskTypeControllerUpdateData, ThrowOnError>): RequestResult<RiskTypeControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<RiskTypeControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/risk-types/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1RiskTypeControllerList = <ThrowOnError extends boolean = false>(options?: Options<V1RiskTypeControllerListData, ThrowOnError>): RequestResult<V1RiskTypeControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1RiskTypeControllerListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-types',
    ...options
});

export const v1RiskTypeControllerCreate = <ThrowOnError extends boolean = false>(options: Options<V1RiskTypeControllerCreateData, ThrowOnError>): RequestResult<V1RiskTypeControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1RiskTypeControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1RiskTypeControllerDelete = <ThrowOnError extends boolean = false>(options: Options<V1RiskTypeControllerDeleteData, ThrowOnError>): RequestResult<V1RiskTypeControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1RiskTypeControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-types/{id}',
    ...options
});

export const v1RiskTypeControllerRead = <ThrowOnError extends boolean = false>(options: Options<V1RiskTypeControllerReadData, ThrowOnError>): RequestResult<V1RiskTypeControllerReadResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1RiskTypeControllerReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-types/{id}',
    ...options
});

export const v1RiskTypeControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<V1RiskTypeControllerUpdateData, ThrowOnError>): RequestResult<V1RiskTypeControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1RiskTypeControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/risk-types/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const scenarioTypeControllerList = <ThrowOnError extends boolean = false>(options?: Options<ScenarioTypeControllerListData, ThrowOnError>): RequestResult<ScenarioTypeControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ScenarioTypeControllerListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/scenario-types',
    ...options
});

/**
 * @deprecated
 */
export const scenarioTypeControllerCreate = <ThrowOnError extends boolean = false>(options: Options<ScenarioTypeControllerCreateData, ThrowOnError>): RequestResult<ScenarioTypeControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<ScenarioTypeControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/scenario-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const scenarioTypeControllerDelete = <ThrowOnError extends boolean = false>(options: Options<ScenarioTypeControllerDeleteData, ThrowOnError>): RequestResult<ScenarioTypeControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ScenarioTypeControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/scenario-types/{id}',
    ...options
});

/**
 * @deprecated
 */
export const scenarioTypeControllerRead = <ThrowOnError extends boolean = false>(options: Options<ScenarioTypeControllerReadData, ThrowOnError>): RequestResult<ScenarioTypeControllerReadResponses, unknown, ThrowOnError> => (options.client ?? client).get<ScenarioTypeControllerReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/scenario-types/{id}',
    ...options
});

/**
 * @deprecated
 */
export const scenarioTypeControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<ScenarioTypeControllerUpdateData, ThrowOnError>): RequestResult<ScenarioTypeControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<ScenarioTypeControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/scenario-types/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ScenarioTypeControllerList = <ThrowOnError extends boolean = false>(options?: Options<V1ScenarioTypeControllerListData, ThrowOnError>): RequestResult<V1ScenarioTypeControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1ScenarioTypeControllerListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/scenario-types',
    ...options
});

export const v1ScenarioTypeControllerCreate = <ThrowOnError extends boolean = false>(options: Options<V1ScenarioTypeControllerCreateData, ThrowOnError>): RequestResult<V1ScenarioTypeControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1ScenarioTypeControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/scenario-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ScenarioTypeControllerDelete = <ThrowOnError extends boolean = false>(options: Options<V1ScenarioTypeControllerDeleteData, ThrowOnError>): RequestResult<V1ScenarioTypeControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1ScenarioTypeControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/scenario-types/{id}',
    ...options
});

export const v1ScenarioTypeControllerRead = <ThrowOnError extends boolean = false>(options: Options<V1ScenarioTypeControllerReadData, ThrowOnError>): RequestResult<V1ScenarioTypeControllerReadResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1ScenarioTypeControllerReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/scenario-types/{id}',
    ...options
});

export const v1ScenarioTypeControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<V1ScenarioTypeControllerUpdateData, ThrowOnError>): RequestResult<V1ScenarioTypeControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1ScenarioTypeControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/scenario-types/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const solutionTypeControllerGetCategories = <ThrowOnError extends boolean = false>(options?: Options<SolutionTypeControllerGetCategoriesData, ThrowOnError>): RequestResult<SolutionTypeControllerGetCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SolutionTypeControllerGetCategoriesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/solution-types/categories',
    ...options
});

/**
 * @deprecated
 */
export const solutionTypeControllerList = <ThrowOnError extends boolean = false>(options?: Options<SolutionTypeControllerListData, ThrowOnError>): RequestResult<SolutionTypeControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SolutionTypeControllerListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/solution-types',
    ...options
});

/**
 * @deprecated
 */
export const solutionTypeControllerCreate = <ThrowOnError extends boolean = false>(options: Options<SolutionTypeControllerCreateData, ThrowOnError>): RequestResult<SolutionTypeControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<SolutionTypeControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/solution-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const solutionTypeControllerDelete = <ThrowOnError extends boolean = false>(options: Options<SolutionTypeControllerDeleteData, ThrowOnError>): RequestResult<SolutionTypeControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<SolutionTypeControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/solution-types/{id}',
    ...options
});

/**
 * @deprecated
 */
export const solutionTypeControllerRead = <ThrowOnError extends boolean = false>(options: Options<SolutionTypeControllerReadData, ThrowOnError>): RequestResult<SolutionTypeControllerReadResponses, unknown, ThrowOnError> => (options.client ?? client).get<SolutionTypeControllerReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/solution-types/{id}',
    ...options
});

/**
 * @deprecated
 */
export const solutionTypeControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<SolutionTypeControllerUpdateData, ThrowOnError>): RequestResult<SolutionTypeControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<SolutionTypeControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/solution-types/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1SolutionTypeControllerGetCategories = <ThrowOnError extends boolean = false>(options?: Options<V1SolutionTypeControllerGetCategoriesData, ThrowOnError>): RequestResult<V1SolutionTypeControllerGetCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1SolutionTypeControllerGetCategoriesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/solution-types/categories',
    ...options
});

export const v1SolutionTypeControllerList = <ThrowOnError extends boolean = false>(options?: Options<V1SolutionTypeControllerListData, ThrowOnError>): RequestResult<V1SolutionTypeControllerListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1SolutionTypeControllerListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/solution-types',
    ...options
});

export const v1SolutionTypeControllerCreate = <ThrowOnError extends boolean = false>(options: Options<V1SolutionTypeControllerCreateData, ThrowOnError>): RequestResult<V1SolutionTypeControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1SolutionTypeControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/solution-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1SolutionTypeControllerPreview = <ThrowOnError extends boolean = false>(options?: Options<V1SolutionTypeControllerPreviewData, ThrowOnError>): RequestResult<V1SolutionTypeControllerPreviewResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1SolutionTypeControllerPreviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/solution-types/preview',
    ...options
});

export const v1SolutionTypeControllerDelete = <ThrowOnError extends boolean = false>(options: Options<V1SolutionTypeControllerDeleteData, ThrowOnError>): RequestResult<V1SolutionTypeControllerDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1SolutionTypeControllerDeleteResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/solution-types/{id}',
    ...options
});

export const v1SolutionTypeControllerRead = <ThrowOnError extends boolean = false>(options: Options<V1SolutionTypeControllerReadData, ThrowOnError>): RequestResult<V1SolutionTypeControllerReadResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1SolutionTypeControllerReadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/solution-types/{id}',
    ...options
});

export const v1SolutionTypeControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<V1SolutionTypeControllerUpdateData, ThrowOnError>): RequestResult<V1SolutionTypeControllerUpdateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1SolutionTypeControllerUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/solution-types/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const solutionImageControllerGetSolutionImages = <ThrowOnError extends boolean = false>(options: Options<SolutionImageControllerGetSolutionImagesData, ThrowOnError>): RequestResult<SolutionImageControllerGetSolutionImagesResponses, unknown, ThrowOnError> => (options.client ?? client).get<SolutionImageControllerGetSolutionImagesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/solution-types/{solutionTypeId}/images',
    ...options
});

/**
 * @deprecated
 */
export const solutionImageControllerUploadSolutionImage = <ThrowOnError extends boolean = false>(options: Options<SolutionImageControllerUploadSolutionImageData, ThrowOnError>): RequestResult<SolutionImageControllerUploadSolutionImageResponses, unknown, ThrowOnError> => (options.client ?? client).post<SolutionImageControllerUploadSolutionImageResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/solution-types/{solutionTypeId}/images',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const solutionImageControllerDeleteSolutionImage = <ThrowOnError extends boolean = false>(options: Options<SolutionImageControllerDeleteSolutionImageData, ThrowOnError>): RequestResult<SolutionImageControllerDeleteSolutionImageResponses, unknown, ThrowOnError> => (options.client ?? client).delete<SolutionImageControllerDeleteSolutionImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/solution-types/{solutionTypeId}/images/{imageId}',
    ...options
});

/**
 * @deprecated
 */
export const solutionImageControllerGetSolutionImage = <ThrowOnError extends boolean = false>(options: Options<SolutionImageControllerGetSolutionImageData, ThrowOnError>): RequestResult<SolutionImageControllerGetSolutionImageResponses, unknown, ThrowOnError> => (options.client ?? client).get<SolutionImageControllerGetSolutionImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/solution-types/{solutionTypeId}/images/{imageId}',
    ...options
});

/**
 * @deprecated
 */
export const solutionImageControllerGetBatchSolutionImages = <ThrowOnError extends boolean = false>(options: Options<SolutionImageControllerGetBatchSolutionImagesData, ThrowOnError>): RequestResult<SolutionImageControllerGetBatchSolutionImagesResponses, unknown, ThrowOnError> => (options.client ?? client).post<SolutionImageControllerGetBatchSolutionImagesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/solution-images/batch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1SolutionImageControllerGetSolutionImages = <ThrowOnError extends boolean = false>(options: Options<V1SolutionImageControllerGetSolutionImagesData, ThrowOnError>): RequestResult<V1SolutionImageControllerGetSolutionImagesResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1SolutionImageControllerGetSolutionImagesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/solution-types/{solutionTypeId}/images',
    ...options
});

export const v1SolutionImageControllerUploadSolutionImage = <ThrowOnError extends boolean = false>(options: Options<V1SolutionImageControllerUploadSolutionImageData, ThrowOnError>): RequestResult<V1SolutionImageControllerUploadSolutionImageResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1SolutionImageControllerUploadSolutionImageResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/solution-types/{solutionTypeId}/images',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const v1SolutionImageControllerDeleteSolutionImage = <ThrowOnError extends boolean = false>(options: Options<V1SolutionImageControllerDeleteSolutionImageData, ThrowOnError>): RequestResult<V1SolutionImageControllerDeleteSolutionImageResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1SolutionImageControllerDeleteSolutionImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/solution-types/{solutionTypeId}/images/{imageId}',
    ...options
});

export const v1SolutionImageControllerGetSolutionImage = <ThrowOnError extends boolean = false>(options: Options<V1SolutionImageControllerGetSolutionImageData, ThrowOnError>): RequestResult<V1SolutionImageControllerGetSolutionImageResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1SolutionImageControllerGetSolutionImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/solution-types/{solutionTypeId}/images/{imageId}',
    ...options
});

export const v1SolutionImageControllerGetBatchSolutionImages = <ThrowOnError extends boolean = false>(options: Options<V1SolutionImageControllerGetBatchSolutionImagesData, ThrowOnError>): RequestResult<V1SolutionImageControllerGetBatchSolutionImagesResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1SolutionImageControllerGetBatchSolutionImagesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/solution-images/batch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const proxyControllerIngest = <ThrowOnError extends boolean = false>(options?: Options<ProxyControllerIngestData, ThrowOnError>): RequestResult<ProxyControllerIngestResponses, ProxyControllerIngestErrors, ThrowOnError> => (options?.client ?? client).post<ProxyControllerIngestResponses, ProxyControllerIngestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy/sentry',
    ...options
});

export const v1ProxyControllerIngest = <ThrowOnError extends boolean = false>(options?: Options<V1ProxyControllerIngestData, ThrowOnError>): RequestResult<V1ProxyControllerIngestResponses, V1ProxyControllerIngestErrors, ThrowOnError> => (options?.client ?? client).post<V1ProxyControllerIngestResponses, V1ProxyControllerIngestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/proxy/sentry',
    ...options
});

/**
 * @deprecated
 */
export const reportControllerUploadPdf = <ThrowOnError extends boolean = false>(options: Options<ReportControllerUploadPdfData, ThrowOnError>): RequestResult<ReportControllerUploadPdfResponses, unknown, ThrowOnError> => (options.client ?? client).post<ReportControllerUploadPdfResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/report/upload-pdf',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const reportControllerGeneratePdf = <ThrowOnError extends boolean = false>(options: Options<ReportControllerGeneratePdfData, ThrowOnError>): RequestResult<ReportControllerGeneratePdfResponses, unknown, ThrowOnError> => (options.client ?? client).post<ReportControllerGeneratePdfResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/report/generate-pdf',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ReportControllerUploadPdf = <ThrowOnError extends boolean = false>(options: Options<V1ReportControllerUploadPdfData, ThrowOnError>): RequestResult<V1ReportControllerUploadPdfResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1ReportControllerUploadPdfResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/report/upload-pdf',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1ReportControllerGeneratePdf = <ThrowOnError extends boolean = false>(options: Options<V1ReportControllerGeneratePdfData, ThrowOnError>): RequestResult<V1ReportControllerGeneratePdfResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1ReportControllerGeneratePdfResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/report/generate-pdf',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const learningMaterialsControllerListHtmlFiles = <ThrowOnError extends boolean = false>(options?: Options<LearningMaterialsControllerListHtmlFilesData, ThrowOnError>): RequestResult<LearningMaterialsControllerListHtmlFilesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<LearningMaterialsControllerListHtmlFilesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/learning-materials',
    ...options
});

export const v1LearningMaterialsControllerListHtmlFiles = <ThrowOnError extends boolean = false>(options?: Options<V1LearningMaterialsControllerListHtmlFilesData, ThrowOnError>): RequestResult<V1LearningMaterialsControllerListHtmlFilesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<V1LearningMaterialsControllerListHtmlFilesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/learning-materials',
    ...options
});

/**
 * @deprecated
 */
export const webReportControllerGet = <ThrowOnError extends boolean = false>(options: Options<WebReportControllerGetData, ThrowOnError>): RequestResult<WebReportControllerGetResponses, unknown, ThrowOnError> => (options.client ?? client).get<WebReportControllerGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/web-report/projects/{projectId}',
    ...options
});

/**
 * @deprecated
 */
export const webReportControllerCreate = <ThrowOnError extends boolean = false>(options: Options<WebReportControllerCreateData, ThrowOnError>): RequestResult<WebReportControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<WebReportControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/web-report/projects/{projectId}',
    ...options
});

/**
 * @deprecated
 */
export const webReportControllerUpdateTemplate = <ThrowOnError extends boolean = false>(options: Options<WebReportControllerUpdateTemplateData, ThrowOnError>): RequestResult<WebReportControllerUpdateTemplateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<WebReportControllerUpdateTemplateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/web-report/projects/{projectId}/template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const webReportControllerPublish = <ThrowOnError extends boolean = false>(options: Options<WebReportControllerPublishData, ThrowOnError>): RequestResult<WebReportControllerPublishResponses, unknown, ThrowOnError> => (options.client ?? client).post<WebReportControllerPublishResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/web-report/projects/{projectId}/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const webReportControllerListAccess = <ThrowOnError extends boolean = false>(options: Options<WebReportControllerListAccessData, ThrowOnError>): RequestResult<WebReportControllerListAccessResponses, unknown, ThrowOnError> => (options.client ?? client).get<WebReportControllerListAccessResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/web-report/projects/{projectId}/access',
    ...options
});

/**
 * @deprecated
 */
export const webReportControllerRevokeAccess = <ThrowOnError extends boolean = false>(options: Options<WebReportControllerRevokeAccessData, ThrowOnError>): RequestResult<WebReportControllerRevokeAccessResponses, unknown, ThrowOnError> => (options.client ?? client).delete<WebReportControllerRevokeAccessResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/web-report/access/{accessId}/revoke',
    ...options
});

/**
 * @deprecated
 */
export const webReportControllerRenewAccess = <ThrowOnError extends boolean = false>(options: Options<WebReportControllerRenewAccessData, ThrowOnError>): RequestResult<WebReportControllerRenewAccessResponses, unknown, ThrowOnError> => (options.client ?? client).patch<WebReportControllerRenewAccessResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/web-report/access/{accessId}/renew',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const webReportControllerResendAccess = <ThrowOnError extends boolean = false>(options: Options<WebReportControllerResendAccessData, ThrowOnError>): RequestResult<WebReportControllerResendAccessResponses, unknown, ThrowOnError> => (options.client ?? client).post<WebReportControllerResendAccessResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/web-report/access/{accessId}/resend',
    ...options
});

/**
 * @deprecated
 */
export const webReportControllerGetPublicReport = <ThrowOnError extends boolean = false>(options: Options<WebReportControllerGetPublicReportData, ThrowOnError>): RequestResult<WebReportControllerGetPublicReportResponses, unknown, ThrowOnError> => (options.client ?? client).get<WebReportControllerGetPublicReportResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/web-report/view/{accessToken}',
    ...options
});

/**
 * @deprecated
 */
export const webReportControllerGetPublicCoverImage = <ThrowOnError extends boolean = false>(options: Options<WebReportControllerGetPublicCoverImageData, ThrowOnError>): RequestResult<WebReportControllerGetPublicCoverImageResponses, unknown, ThrowOnError> => (options.client ?? client).get<WebReportControllerGetPublicCoverImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/web-report/view/{accessToken}/cover-image/{projectId}',
    ...options
});

/**
 * @deprecated
 */
export const webReportControllerGetPublicScenarioImage = <ThrowOnError extends boolean = false>(options: Options<WebReportControllerGetPublicScenarioImageData, ThrowOnError>): RequestResult<WebReportControllerGetPublicScenarioImageResponses, unknown, ThrowOnError> => (options.client ?? client).get<WebReportControllerGetPublicScenarioImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/web-report/view/{accessToken}/scenario-images/{imageId}',
    ...options
});

/**
 * @deprecated
 */
export const webReportControllerGetPublicSolutionImage = <ThrowOnError extends boolean = false>(options: Options<WebReportControllerGetPublicSolutionImageData, ThrowOnError>): RequestResult<WebReportControllerGetPublicSolutionImageResponses, unknown, ThrowOnError> => (options.client ?? client).get<WebReportControllerGetPublicSolutionImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/web-report/view/{accessToken}/solution-images/{imageId}',
    ...options
});

export const v1WebReportControllerGet = <ThrowOnError extends boolean = false>(options: Options<V1WebReportControllerGetData, ThrowOnError>): RequestResult<V1WebReportControllerGetResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1WebReportControllerGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/web-report/projects/{projectId}',
    ...options
});

export const v1WebReportControllerCreate = <ThrowOnError extends boolean = false>(options: Options<V1WebReportControllerCreateData, ThrowOnError>): RequestResult<V1WebReportControllerCreateResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1WebReportControllerCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/web-report/projects/{projectId}',
    ...options
});

export const v1WebReportControllerUpdateTemplate = <ThrowOnError extends boolean = false>(options: Options<V1WebReportControllerUpdateTemplateData, ThrowOnError>): RequestResult<V1WebReportControllerUpdateTemplateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1WebReportControllerUpdateTemplateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/web-report/projects/{projectId}/template',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1WebReportControllerPublish = <ThrowOnError extends boolean = false>(options: Options<V1WebReportControllerPublishData, ThrowOnError>): RequestResult<V1WebReportControllerPublishResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1WebReportControllerPublishResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/web-report/projects/{projectId}/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1WebReportControllerListAccess = <ThrowOnError extends boolean = false>(options: Options<V1WebReportControllerListAccessData, ThrowOnError>): RequestResult<V1WebReportControllerListAccessResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1WebReportControllerListAccessResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/web-report/projects/{projectId}/access',
    ...options
});

export const v1WebReportControllerRevokeAccess = <ThrowOnError extends boolean = false>(options: Options<V1WebReportControllerRevokeAccessData, ThrowOnError>): RequestResult<V1WebReportControllerRevokeAccessResponses, unknown, ThrowOnError> => (options.client ?? client).delete<V1WebReportControllerRevokeAccessResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/web-report/access/{accessId}/revoke',
    ...options
});

export const v1WebReportControllerRenewAccess = <ThrowOnError extends boolean = false>(options: Options<V1WebReportControllerRenewAccessData, ThrowOnError>): RequestResult<V1WebReportControllerRenewAccessResponses, unknown, ThrowOnError> => (options.client ?? client).patch<V1WebReportControllerRenewAccessResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/web-report/access/{accessId}/renew',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1WebReportControllerResendAccess = <ThrowOnError extends boolean = false>(options: Options<V1WebReportControllerResendAccessData, ThrowOnError>): RequestResult<V1WebReportControllerResendAccessResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1WebReportControllerResendAccessResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/web-report/access/{accessId}/resend',
    ...options
});

export const v1WebReportControllerGetPublicReport = <ThrowOnError extends boolean = false>(options: Options<V1WebReportControllerGetPublicReportData, ThrowOnError>): RequestResult<V1WebReportControllerGetPublicReportResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1WebReportControllerGetPublicReportResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/web-report/view/{accessToken}',
    ...options
});

export const v1WebReportControllerGetPublicCoverImage = <ThrowOnError extends boolean = false>(options: Options<V1WebReportControllerGetPublicCoverImageData, ThrowOnError>): RequestResult<V1WebReportControllerGetPublicCoverImageResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1WebReportControllerGetPublicCoverImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/web-report/view/{accessToken}/cover-image/{projectId}',
    ...options
});

export const v1WebReportControllerGetPublicScenarioImage = <ThrowOnError extends boolean = false>(options: Options<V1WebReportControllerGetPublicScenarioImageData, ThrowOnError>): RequestResult<V1WebReportControllerGetPublicScenarioImageResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1WebReportControllerGetPublicScenarioImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/web-report/view/{accessToken}/scenario-images/{imageId}',
    ...options
});

export const v1WebReportControllerGetPublicSolutionImage = <ThrowOnError extends boolean = false>(options: Options<V1WebReportControllerGetPublicSolutionImageData, ThrowOnError>): RequestResult<V1WebReportControllerGetPublicSolutionImageResponses, unknown, ThrowOnError> => (options.client ?? client).get<V1WebReportControllerGetPublicSolutionImageResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/web-report/view/{accessToken}/solution-images/{imageId}',
    ...options
});

/**
 * @deprecated
 */
export const textRefinementControllerStreamRefinement = <ThrowOnError extends boolean = false>(options: Options<TextRefinementControllerStreamRefinementData, ThrowOnError>): RequestResult<TextRefinementControllerStreamRefinementResponses, unknown, ThrowOnError> => (options.client ?? client).post<TextRefinementControllerStreamRefinementResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/text-refinements',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const textRefinementControllerStreamTranslation = <ThrowOnError extends boolean = false>(options: Options<TextRefinementControllerStreamTranslationData, ThrowOnError>): RequestResult<TextRefinementControllerStreamTranslationResponses, unknown, ThrowOnError> => (options.client ?? client).post<TextRefinementControllerStreamTranslationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/text-translations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const textRefinementControllerStreamShortening = <ThrowOnError extends boolean = false>(options: Options<TextRefinementControllerStreamShorteningData, ThrowOnError>): RequestResult<TextRefinementControllerStreamShorteningResponses, unknown, ThrowOnError> => (options.client ?? client).post<TextRefinementControllerStreamShorteningResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/text-shortenings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1TextRefinementControllerStreamRefinement = <ThrowOnError extends boolean = false>(options: Options<V1TextRefinementControllerStreamRefinementData, ThrowOnError>): RequestResult<V1TextRefinementControllerStreamRefinementResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1TextRefinementControllerStreamRefinementResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/text-refinements',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1TextRefinementControllerStreamTranslation = <ThrowOnError extends boolean = false>(options: Options<V1TextRefinementControllerStreamTranslationData, ThrowOnError>): RequestResult<V1TextRefinementControllerStreamTranslationResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1TextRefinementControllerStreamTranslationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/text-translations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1TextRefinementControllerStreamShortening = <ThrowOnError extends boolean = false>(options: Options<V1TextRefinementControllerStreamShorteningData, ThrowOnError>): RequestResult<V1TextRefinementControllerStreamShorteningResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1TextRefinementControllerStreamShorteningResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/text-shortenings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const telemetryControllerTrack = <ThrowOnError extends boolean = false>(options: Options<TelemetryControllerTrackData, ThrowOnError>): RequestResult<TelemetryControllerTrackResponses, unknown, ThrowOnError> => (options.client ?? client).post<TelemetryControllerTrackResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/telemetry/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const v1TelemetryControllerTrack = <ThrowOnError extends boolean = false>(options: Options<V1TelemetryControllerTrackData, ThrowOnError>): RequestResult<V1TelemetryControllerTrackResponses, unknown, ThrowOnError> => (options.client ?? client).post<V1TelemetryControllerTrackResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/telemetry/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
